import { LoadingIndicatorComponent } from '../../components/loading-indicator/loading-indicator.component';
// @ts-ignore
import { Component, inject, signal, OnInit, ViewChild, ElementRef, EventEmitter, Input, Output, HostListener } from '@angular/core';
// @ts-ignore
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
// @ts-ignore
import { firstValueFrom } from 'rxjs';
// @ts-ignore
import { FormBuilder, FormGroup, FormArray, ReactiveFormsModule, Validators, FormsModule, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { SankhyaGatewayService } from "../../services/sankhya-gateway.service";

export function cpfCnpjValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) return null; // Ignora se estiver vazio (o Validators.required já cuida disso)

        const parent = control.parent;
        if (!parent) return null;

        const tipoPessoa = parent.get('tipoPessoa')?.value;
        const cleanValue = String(control.value).replace(/\D/g, '');

        if (tipoPessoa === 'E') return null;

        if (tipoPessoa === 'F') {
            if (cleanValue.length !== 11 || !isCpfValido(cleanValue)) {
                return { invalidCpf: true }; // Erro específico no campo
            }
        }

        if (tipoPessoa === 'J') {
            if (cleanValue.length !== 14 || !isCnpjValido(cleanValue)) {
                return { invalidCnpj: true }; // Erro específico no campo
            }
        }

        return null;
    };
}

export function cpfCompradorValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) return null; // Ignora se estiver vazio

        const cleanValue = String(control.value).replace(/\D/g, '');

        // Valida diretamente o tamanho e o cálculo do CPF usando sua função existente
        if (cleanValue.length !== 11 || !isCpfValido(cleanValue)) {
            return { invalidCpf: true };
        }

        return null;
    };
}

function isCpfValido(cpf: string): boolean {
    if (/^(\d)\1{10}$/.test(cpf)) return false; // Bloqueia sequências como 111.111.111-11
    let soma = 0, resto;
    for (let i = 1; i <= 9; i++) soma += parseInt(cpf.substring(i - 1, i)) * (11 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.substring(9, 10))) return false;
    soma = 0;
    for (let i = 1; i <= 10; i++) soma += parseInt(cpf.substring(i - 1, i)) * (12 - i);
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.substring(10, 11))) return false;
    return true;
}

function isCnpjValido(cnpj: string): boolean {
    if (/^(\d)\1{13}$/.test(cnpj)) return false;
    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
        soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
        if (pos < 2) pos = 9;
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado !== parseInt(digitos.charAt(0))) return false;
    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
        soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
        if (pos < 2) pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado !== parseInt(digitos.charAt(1))) return false;
    return true;
}

// @ts-ignore
@Component({
    selector: 'app-cadastro-parceiro',
    standalone: true,
    imports: [LoadingIndicatorComponent, CommonModule, ReactiveFormsModule, FormsModule],
    templateUrl: './cadastro-parceiro.component.html',
    styleUrls: ['./cadastro-parceiro.component.scss']
})
export class CadastroParceiroComponent implements OnInit {
    /** Emitido apos salvar com sucesso (a Lista de Parceiros reabre). */
    @Output() salvo = new EventEmitter<void>();
    /** Emitido ao clicar em Voltar (volta para a Lista de Parceiros sem salvar). */
    @Output() voltar = new EventEmitter<void>();

    private fb = inject(FormBuilder);

    @ViewChild('fileInput') fileInput?: ElementRef<HTMLInputElement>;

    // Variável para guardar o último CPF/CNPJ pesquisado
    ultimoCpfCnpjConsultado = '';

    salvando = signal(false);
    buscandoCpfCnpj = signal(false);

    // Listas Fixas
    opcoesIpiEntrada = [
        { valor: '-1', descricao: '(-1) - Não sujeita ao IPI' },
        { valor: '00', descricao: '00 - Entrada c/Recuperação de Crédito' },
        { valor: '01', descricao: '01 - Entrada c/ Alíquota zero' },
        { valor: '02', descricao: '02 - Entrada Isenta' },
        { valor: '03', descricao: '03 - Entrada Não Tributada' },
        { valor: '04', descricao: '04 - Entrada Imune' },
        { valor: '05', descricao: '05 - Entrada c/ Suspensão' },
        { valor: '49', descricao: '49 - Outras Entradas' }
    ];

    opcoesIpiSaida = [
        { valor: '-1', descricao: '(-1) - Não sujeita ao IPI' },
        { valor: '50', descricao: '50 - Saída Tributada' },
        { valor: '51', descricao: '51 - Saída c/ Alíquota zero' },
        { valor: '52', descricao: '52 - Saída Isenta' },
        { valor: '53', descricao: '53 - Saída Não Tributada' },
        { valor: '54', descricao: '54 - Saída Imune' },
        { valor: '55', descricao: '55 - Saída c/ Suspensão' },
        { valor: '99', descricao: '99 - Outras Saídas' }
    ];

    parceiroForm: FormGroup = this.fb.group({
        // Base
        tipoPessoa: ['F', Validators.required],
        cpfCnpj: ['', [Validators.required, cpfCnpjValidator()]],
        nome: ['', [Validators.required]],
        razaoSocial: [''],
        telefone: [''],
        email: ['', [Validators.email]],
        tipoCadastro: ['AVISTA', Validators.required],
        etapaCadastro: ['COMPLETO'],
        ativo: [true],

        // Switches de Classificação
        isCliente: [true],
        isFornecedor: [false],
        isVendedor: [false],
        isUsuario: [false],
        isTransportadora: [false],
        isAgencia: [false],
        isMotorista: [false],

        // Específicos PF
        rg: [''],
        orgaoExpedidor: [''],
        dataEmissaoRg: [''],
        cnh: [''],
        dataVencimentoCnh: [''],
        nomeMae: [''],
        nomePai: [''],
        sexo: ['M'],
        naturalidade: [''],
        dataNascimento: [''],

        // Específicos PJ
        dataAbertura: [''],
        com: [''],

        // Ambos
        limiteCredito: [''],
        bloquearVendaPrazo: ['N'],
        vendedorResponsavel: [''],
        observacao: [''],
        gplConceito: [''],
        gplPendencia: ['OK'],

        // Tributação
        ipiEntrada: ['-1', Validators.required],
        ipiSaida: ['-1', Validators.required],
        classificIcms: ['C', Validators.required],
        consumidorFinal: ['S', Validators.required],
        ipiIncideIcms: [false],
        temIpi: [false],
        optanteSimples: [false],
        regimeTributario: [''],

        // Form Arrays
        enderecos: this.fb.array([this.criarEndereco()]),
        compradores: this.fb.array([]),
        contatos: this.fb.array([]),
        aeronaves: this.fb.array([]),
        fiadores: this.fb.array([]),
        refsBancarias: this.fb.array([])
    });

    // Getters
    get enderecosFormArray(): FormArray { return this.parceiroForm.get('enderecos') as FormArray; }
    get compradoresFormArray(): FormArray { return this.parceiroForm.get('compradores') as FormArray; }
    get contatosFormArray(): FormArray { return this.parceiroForm.get('contatos') as FormArray; }
    get aeronavesFormArray(): FormArray { return this.parceiroForm.get('aeronaves') as FormArray; }
    get fiadoresFormArray(): FormArray { return this.parceiroForm.get('fiadores') as FormArray; }
    get refsBancariasFormArray(): FormArray { return this.parceiroForm.get('refsBancarias') as FormArray; }

    // ==========================================
    // REFERÊNCIAS BANCÁRIAS (GPL_REFBANC_PARCEIRO no Sankhya / PES_REF_BANCARIA no Aerosys)
    // ==========================================
    bancos = signal<{ codBanco: number; nome: string }[]>([]);
    /** Quantas referências existiam ao carregar o parceiro (sequências 1..N) -- usado p/ remover as que sobraram. */
    refsBancariasQtdOriginal = 0;
    /** Tipos de telefone do Aerosys (PES_FONE.PFO_TIPO) -- aplicado ao campo Telefone do contato. */
    readonly tiposTelefone = ['Celular', 'Comercial', 'Fax', 'Outros', 'Recado', 'Residencial', 'Responsável'];
    readonly tiposConta = ['Corrente', 'Poupança', 'Pagamento', 'Salário'];
    readonly tiposChavePix = ['Telefone', 'E-mail', 'CPF/CNPJ', 'Aleatória', 'Dados Bancários'];
    /** Opções do campo nativo TGFPAR.AD_TIPOCHAVEPIX (Tipo de Chave Pix). */
    private readonly codigoTipoChavePixSankhya: Record<string, string> = {
        'Telefone': '01', 'E-mail': '02', 'CPF/CNPJ': '03', 'Aleatória': '04', 'Dados Bancários': '05'
    };

    criarRefBancaria(ativa = true): FormGroup {
        return this.fb.group({
            codBanco: [''],
            tipoConta: ['Corrente'],
            agencia: [''],
            digAgencia: [''],
            conta: [''],
            digConta: [''],
            contaPgto: [false],
            ativa: [ativa],
            tipoChavePix: [''],
            chavePix: [''],
            descricao: ['']
        });
    }

    adicionarRefBancaria(): void {
        // Só uma referência fica ativa (é a que aparece na tela nativa do Sankhya): a nova nasce ativa apenas se não houver outra.
        const haAtiva = this.refsBancariasFormArray.controls.some(c => !!c.get('ativa')?.value);
        this.refsBancariasFormArray.push(this.criarRefBancaria(!haAtiva));
    }

    removerRefBancaria(index: number): void {
        this.refsBancariasFormArray.removeAt(index);
        this.sincronizarTipoAgencia();
    }

    /** Marcou uma referência como ativa: as demais ficam inativas. */
    aoMudarAtivaRefBancaria(index: number): void {
        if (!this.refsBancariasFormArray.at(index).get('ativa')?.value) return;
        this.refsBancariasFormArray.controls.forEach((c, i) => {
            if (i !== index) c.get('ativa')?.setValue(false);
        });
    }

    private refBancariaPreenchida(r: any): boolean {
        return !!(String(r?.codBanco ?? '').trim() || String(r?.conta ?? '').trim() || String(r?.agencia ?? '').trim());
    }

    /** Dados bancários preenchidos => tipo "Agência" habilitado; tudo limpo => desabilitado. */
    sincronizarTipoAgencia(): void {
        const preenchida = this.refsBancariasFormArray.controls.some(c => this.refBancariaPreenchida(c.value));
        const ctrl = this.parceiroForm.get('isAgencia');
        if (ctrl && ctrl.value !== preenchida) ctrl.setValue(preenchida);
    }

    async carregarBancos(): Promise<void> {
        try {
            const res: any = await firstValueFrom(this.sankhyaGateway.listarBancosParceiro());
            this.bancos.set(Array.isArray(res) ? res : []);
        } catch (e) {
            console.error('Erro ao carregar bancos:', e);
        }
    }

    // ==========================================
    // ESTADOS E CONTROLES DE BUSCA SANKHYA
    // ==========================================
    indiceBuscaAtiva = signal<number>(-1);
    filtroBusca = signal<string>('');

    indiceFocoAtual = signal<number>(-1);
    toast = signal<{ mensagem: string, tipo: 'success' | 'danger' | 'warning' | 'info' } | null>(null);

    // Cidades
    cidades = signal<any[]>([]);
    cidadeModalAberta = signal(false);
    ufs = signal<any[]>([]);
    ufSelecionada = signal<any>('');

    // Naturalidade (Dropdown com autocomplete)
    dropdownNaturalidadeAberto = signal(false);
    filtroNaturalidade = signal<string>('');

    // Logradouros
    logradouros = signal<any[]>([]);
    logradouroModalAberta = signal(false);
    modalNovoLogradouroAberto = signal(false);
    logradouroPendente = signal({ nome: '', indexForm: -1 });

    // Bairros
    bairros = signal<any[]>([]);
    bairroModalAberta = signal(false);

    // Aeronaves
    aeronaves = signal<any[]>([]);
    aeronaveModalAberta = signal(false);
    dropdownAeronaveAberto = signal<number>(-1);

    // Vendedores
    vendedores = signal<any[]>([]);
    dropdownVendedorAberto = signal(false);
    filtroVendedor = signal<string>('');
    inputVendedorDisplay = signal<string>(''); // Para display enquanto o usuário digita

    // Fiadores (Parceiros do Sankhya)
    parceirosSankhya = signal<any[]>([]); // Cache para exibir o nome no formulário

    // Controles da Nova Modal de Fiador
    modalFiadorAberta = signal(false);
    filtroBuscaModalFiador = '';
    statusBuscaFiador = signal('Digite ao menos 2 caracteres para pesquisar...');
    listaFiadoresSugeridos = signal<any[]>([]);
    indiceFiadorAtivo = -1; // Qual índice do FormArray chamou a modal
    private buscaFiadorTimer: ReturnType<typeof setTimeout> | null = null;

    buscaColapsada = false;
    dropdownBuscaParceiroGeralAberto = false;
    filtroBuscaModalParceiroGeral = '';
    statusBuscaParceiroGeral = signal('Digite ao menos 2 caracteres para pesquisar...');
    listaParceirosGeralSugeridos = signal<any[]>([]);
    private buscaParceiroGeralTimer: ReturnType<typeof setTimeout> | null = null;

    modalConfirmarLimparAberto = signal(false);
    modalConfirmarSalvarAberto = signal(false);

    arquivosPendentes: File[] = [];
    arquivosExistentes: any[] = [];

    // ── Ordem dos anexos (existentes + pendentes), persistida em GPL_PARCEIRO_ANEXO_ORDEM ──
    ordemChavesAnexos: string[] = [];
    ordemAnexosAlterada = false;
    anexoArrastandoIdx: number | null = null;

    private chaveExistente(a: any): string { return String(a?.DESCRICAO || a?.nomeArquivo || ''); }

    /** Lista unica (existentes + novos) na ordem escolhida pelo usuario. */
    anexosOrdenados(): { key: string; tipo: 'E' | 'P'; nome: string; ex?: any; file?: File }[] {
        const itens: { key: string; tipo: 'E' | 'P'; nome: string; ex?: any; file?: File }[] = [
            ...this.arquivosExistentes.map(ex => ({ key: this.chaveExistente(ex), tipo: 'E' as const, nome: ex.nomeArquivo, ex })),
            ...this.arquivosPendentes.map(f => ({ key: f.name, tipo: 'P' as const, nome: f.name, file: f }))
        ];
        const pos = (k: string) => { const i = this.ordemChavesAnexos.indexOf(k); return i < 0 ? Number.MAX_SAFE_INTEGER : i; };
        return itens
            .map((it, i) => ({ it, i }))
            .sort((a, b) => (pos(a.it.key) - pos(b.it.key)) || (a.i - b.i))
            .map(x => x.it);
    }

    trackAnexo = (_: number, it: { key: string; tipo: string }) => it.tipo + ':' + it.key;

    private fixarOrdemAtual(): string[] {
        this.ordemChavesAnexos = this.anexosOrdenados().map(a => a.key);
        return this.ordemChavesAnexos;
    }

    moverAnexo(idx: number, destino: number): void {
        const chaves = [...this.fixarOrdemAtual()];
        if (destino < 0 || destino >= chaves.length || destino === idx) return;
        const [k] = chaves.splice(idx, 1);
        chaves.splice(destino, 0, k);
        this.ordemChavesAnexos = chaves;
        this.ordemAnexosAlterada = true;
    }

    onAnexoDragStart(idx: number): void { this.anexoArrastandoIdx = idx; }
    onAnexoDrop(idx: number): void {
        if (this.anexoArrastandoIdx != null) this.moverAnexo(this.anexoArrastandoIdx, idx);
        this.anexoArrastandoIdx = null;
    }

    /** Data/hora atual no formato aceito pelo Sankhya (dd/MM/yyyy HH:mm:ss). */
    private dataHoraAgora(): string {
        const d = new Date();
        const p = (n: number) => String(n).padStart(2, '0');
        return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
    }

    /** Anexos já gravados no Sankhya marcados para exclusão (aplicado ao salvar). */
    anexosParaExcluir: any[] = [];

    anexoParaConfirmar = signal<{ tipo: 'E' | 'P'; nome: string; ex?: any; file?: File } | null>(null);

    pedirExclusaoAnexo(it: { tipo: 'E' | 'P'; nome: string; ex?: any; file?: File }): void {
        this.anexoParaConfirmar.set(it);
    }

    cancelarExclusaoAnexo(): void {
        this.anexoParaConfirmar.set(null);
    }

    confirmarExclusaoAnexo(): void {
        const it = this.anexoParaConfirmar();
        this.anexoParaConfirmar.set(null);
        if (!it) return;
        if (it.tipo === 'E') this.removerAnexoExistente(it.ex);
        else if (it.file) this.removerAnexoPendente(it.file);
    }

    removerAnexoExistente(ex: any): void {
        this.arquivosExistentes = this.arquivosExistentes.filter(a => a !== ex);
        this.anexosParaExcluir.push(ex);
    }

    private async excluirAnexosRemovidos(): Promise<void> {
        const lista = [...this.anexosParaExcluir];
        this.anexosParaExcluir = [];
        for (const ex of lista) {
            try {
                const r: any = await firstValueFrom(this.sankhyaGateway.excluirAnexoParceiro(ex.CODATA, ex.DESCRICAO));
                const ok = r?.responseBody?.sucesso ?? r?.sucesso;
                if (ok === false) {
                    const erro = r?.responseBody?.erro ?? r?.erro ?? 'erro desconhecido';
                    console.error('Anexo não excluído:', ex?.DESCRICAO, erro);
                    this.exibirToast(`Não foi possível excluir o anexo ${ex?.nomeArquivo || ex?.DESCRICAO}: ${erro}`, 'danger');
                }
            } catch (e) {
                console.error('Erro ao excluir anexo:', ex?.DESCRICAO, e);
                this.exibirToast(`Não foi possível excluir o anexo ${ex?.nomeArquivo || ex?.DESCRICAO}.`, 'danger');
            }
        }
    }

    removerAnexoPendente(file: File): void {
        const i = this.arquivosPendentes.indexOf(file);
        if (i >= 0) this.removerArquivo(i);
    }

    enderecosParaExcluir: any[] = [];
    contatosParaExcluir: any[] = [];
    aeronavesParaExcluir: any[] = [];
    fiadoresParaExcluir: any[] = [];
    compradoresParaExcluir: any[] = [];

    // Variável para evitar o travamento por excesso de requisições ao digitar
    debounceConsulta: any;

    constructor(private sankhyaGateway: SankhyaGatewayService) {}

    /** CPF/CNPJ do parceiro a abrir em edicao (vindo da Lista de Parceiros, duplo clique). */
    @Input() docParceiroEdicao: string | null = null;
    /** Codigo (CODPARC) do parceiro em edicao -- so para exibir no cabecalho. */
    @Input() codParcEdicao: string | number | null = null;

    /** CPF/CNPJ de um cliente do Aerosys ainda NAO cadastrado no Sankhya (vindo de "Validar clientes do Aerosys"): abre o cadastro novo ja com o documento consultado. */
    @Input() docParceiroNovo: string | null = null;
    /** Nome do cliente no Aerosys -- usado so se a consulta nao trouxer nome (ex.: CPF). */
    @Input() nomeParceiroNovo: string | null = null;

    ngOnInit(): void {
        if (this.docParceiroEdicao) {
            const doc = this.docParceiroEdicao;
            setTimeout(() => this.selecionarParceiroGeral({ docparc: doc }), 0);
        } else if (this.docParceiroNovo) {
            const doc = String(this.docParceiroNovo).replace(/\D/g, '');
            const nomeAerosys = this.nomeParceiroNovo || '';
            setTimeout(async () => {
                if (!doc) return;
                this.parceiroForm.get('tipoPessoa')?.setValue(doc.length > 11 ? 'J' : 'F');
                this.parceiroForm.get('cpfCnpj')?.setValue(doc);
                this.aplicarMascaraCpfCnpj({ target: { value: doc } });
                await this.onCpfCnpjBlur();
                const nomeCtrl = this.parceiroForm.get('nome');
                if (nomeAerosys && nomeCtrl && !String(nomeCtrl.value || '').trim()) {
                    nomeCtrl.setValue(nomeAerosys.toUpperCase());
                }
            }, 0);
        }
        // Validação dinâmica para Razão Social dependendo do tipo de pessoa
        this.parceiroForm.get('tipoPessoa')?.valueChanges.subscribe((tipo: string) => {
            this.limparFormularioParcial();
            const razaoSocialControl = this.parceiroForm.get('razaoSocial');
            const campoCOM = this.parceiroForm.get('com');
            const rgControl = this.parceiroForm.get('rg');
            const orgaoEmissorControl = this.parceiroForm.get('orgaoEmissor');
            const cnhControl = this.parceiroForm.get('cnh');

            if (tipo === 'J') {
                razaoSocialControl?.setValidators([Validators.required]);
                campoCOM?.setValidators([Validators.maxLength(20)]);
            } else {
                campoCOM?.clearValidators();
                razaoSocialControl?.clearValidators();
            }

            if (tipo === 'F') {
                rgControl?.setValidators([Validators.maxLength(20)]);
                orgaoEmissorControl?.setValidators([Validators.maxLength(20)]);
                cnhControl?.setValidators([Validators.maxLength(20)]);
            } else {
                rgControl?.clearValidators();
                orgaoEmissorControl?.clearValidators();
                cnhControl?.clearValidators();
            }

            rgControl?.updateValueAndValidity();
            orgaoEmissorControl?.updateValueAndValidity();
            cnhControl?.updateValueAndValidity();
            campoCOM?.updateValueAndValidity();
            razaoSocialControl?.updateValueAndValidity();

            const cpfCnpjControl = this.parceiroForm.get('cpfCnpj');
            if (cpfCnpjControl?.value) {
                this.aplicarMascaraCpfCnpj({ target: { value: cpfCnpjControl.value } });
            }

            this.parceiroForm.get('cpfCnpj')?.updateValueAndValidity();
        });

        this.parceiroForm.get('optanteSimples')?.valueChanges.subscribe((isSimples: boolean) => {
            const regimeCtrl = this.parceiroForm.get('regimeTributario');
            const classifIcmsCtrl = this.parceiroForm.get('classificIcms');

            if (isSimples) {
                regimeCtrl?.setValue('');
                regimeCtrl?.disable(); // Trava o campo de Lucro Real/Presumido
            } else {
                regimeCtrl?.enable(); // Destrava o campo
            }
        });

        this.carregarListasIniciais();
        this.carregarVendedores();
        this.carregarBancos();
    }

    limparFormulario(): void {
        this.ultimoCpfCnpjConsultado = '';
        // Limpa os FormArrays filhos para não acumularem linhas antigas
        while (this.enderecosFormArray.length) this.enderecosFormArray.removeAt(0);
        while (this.compradoresFormArray.length) this.compradoresFormArray.removeAt(0);
        while (this.contatosFormArray.length) this.contatosFormArray.removeAt(0);
        while (this.aeronavesFormArray.length) this.aeronavesFormArray.removeAt(0);
        while (this.fiadoresFormArray.length) this.fiadoresFormArray.removeAt(0);
        while (this.refsBancariasFormArray.length) this.refsBancariasFormArray.removeAt(0);
        this.refsBancariasQtdOriginal = 0;

        // Insere novamente a linha padrão de endereço inicial
        this.adicionarEndereco();

        // Reseta as propriedades primitivas aos seus estados e seleções padrão
        this.parceiroForm.reset({
            tipoPessoa: 'F',
            cpfCnpj: '',
            nome: '',
            razaoSocial: '',
            telefone: '',
            email: '',
            tipoCadastro: 'AVISTA',
            etapaCadastro: 'COMPLETO',
            ativo: true,
            isCliente: true,
            isFornecedor: false,
            isVendedor: false,
            isUsuario: false,
            isTransportadora: false,
            isAgencia: false,
            isMotorista: false,
            rg: '',
            orgaoExpedidor: '',
            dataEmissaoRg: '',
            cnh: '',
            dataVencimentoCnh: '',
            nomeMae: '',
            nomePai: '',
            sexo: 'M',
            naturalidade: '',
            dataNascimento: '',
            dataAbertura: '',
            com: '',
            limiteCredito: '',
            bloquearVendaPrazo: 'N',
            vendedorResponsavel: '',
            observacao: '',
            ipiEntrada: '-1',
            ipiSaida: '-1',
            classificIcms: 'C',
            consumidorFinal: 'S',
            ipiIncideIcms: false,
            temIpi: false,
            optanteSimples: false,
            regimeTributario: ''
        }, { emitEvent: false });

        // Zera os estados de controle dos campos com Autocomplete e uploads pendentes
        this.filtroBuscaModalParceiroGeral = '';
        this.listaParceirosGeralSugeridos.set([]);
        this.dropdownBuscaParceiroGeralAberto = false;
        this.buscaColapsada = false;
        this.inputVendedorDisplay.set('');
        this.filtroVendedor.set('');
        this.filtroNaturalidade.set('');
        this.limparThumbs();
        this.arquivosPendentes = [];
        this.arquivosExistentes = [];
        this.anexosParaExcluir = [];
        this.ordemChavesAnexos = [];
        this.ordemAnexosAlterada = false;
        this.enderecosParaExcluir = [];
        this.contatosParaExcluir = [];
        this.aeronavesParaExcluir = [];
        this.fiadoresParaExcluir = [];
        this.compradoresParaExcluir = [];
        if (this.fileInput && this.fileInput.nativeElement) {
            this.fileInput.nativeElement.value = '';
        }

        // Limpa o estado visual de validações (erros vermelhos por campos tocados)
        this.parceiroForm.markAsPristine();
        this.parceiroForm.markAsUntouched();
    }

    private limparFormularioParcial(): void {
        const tipoPessoa = this.parceiroForm.get('tipoPessoa')?.value;
        const buscaGeral = this.filtroBuscaModalParceiroGeral;

        // Salva os valores que não devem ser limpos
        const valoresPreservados = {
            tipoPessoa: tipoPessoa
        };

        this.limparFormulario();

        this.parceiroForm.patchValue(valoresPreservados, { emitEvent: false });
        this.filtroBuscaModalParceiroGeral = buscaGeral;
    }

    private limparFormularioParcialDeixandoCpfCnpj(): void {
        const tipoPessoa = this.parceiroForm.get('tipoPessoa')?.value;
        const cpfCnpj = this.parceiroForm.get('cpfCnpj')?.value;
        const buscaGeral = this.filtroBuscaModalParceiroGeral;

        // Salva os valores que não devem ser limpos
        const valoresPreservados = {
            tipoPessoa: tipoPessoa,
            cpfCnpj: cpfCnpj
        };

        this.limparFormulario();
        this.parceiroForm.patchValue(valoresPreservados, { emitEvent: false });
        this.filtroBuscaModalParceiroGeral = buscaGeral;
    }

    async carregarVendedores(): Promise<void> {
        try {
            const res: any = await firstValueFrom(this.sankhyaGateway.buscarVendedoresPedidoVenda());
            const body = res?.responseBody ?? res;
            const vendedoresCarregados = body?.vendedores ?? [];
            this.vendedores.set(vendedoresCarregados);
        } catch (err) {
            console.error('Erro ao carregar vendedores:', err);
        }
    }

    async onCpfCnpjBlur() {
        const { value: rawValue, invalid } = this.parceiroForm.get('cpfCnpj') ?? {};

        if (!rawValue || invalid) {
            return;
        }

        const cpfCnpj = this.extrairNumeros(rawValue);
        if (!cpfCnpj) {
            return;
        }

        if (cpfCnpj === this.ultimoCpfCnpjConsultado) {
            return;
        }

        this.buscandoCpfCnpj.set(true);

        try {
            this.ultimoCpfCnpjConsultado = cpfCnpj;

            const response: any = await firstValueFrom(this.sankhyaGateway.buscarParceiroPorCpfCnpj(cpfCnpj));
            const responseBody = response?.responseBody;

            if (responseBody?.sucesso) {
                this.limparFormularioParcialDeixandoCpfCnpj();
                this._preencherFormularioComParceiro(responseBody.parceiro);
                await this.carregarAnexosDoParceiro(responseBody.parceiro.listaEndereco);
                this.exibirToast('Parceiro encontrado e dados carregados do Sankhya.',  'success');
            } else {
                if (responseBody?.erro) {
                    const valorDigitado = this.parceiroForm.get('cpfCnpj')?.value || '';
                    const docLimpo = valorDigitado.replace(/\D/g, '');

                    this.limparFormularioParcialDeixandoCpfCnpj();
                    
                    this.ultimoCpfCnpjConsultado = cpfCnpj;

                    if (docLimpo.length === 14) {
                        await this.preencherComReceitaWS(docLimpo);
                    } else {
                        this.exibirToast(responseBody.erro, 'success');
                    }
                } else {
                    this.exibirToast('Erro inesperado, contate a administração do sistema.', 'warning');
                }
            }
        } catch (err) {
            console.error('Erro ao buscar parceiro por CPF/CNPJ:', err);
            this.exibirToast('Erro ao consultar CPF/CNPJ. Tente novamente.', 'warning');
        } finally {
            this.buscandoCpfCnpj.set(false);
        }
    }

    private _preencherFormularioComParceiro(parceiro: any): void {
        // 1. Preencher os dados principais (escalares)
        this.parceiroForm.patchValue({
            nome: parceiro.nomeParceiro,
            razaoSocial: parceiro.razaoSocial,
            telefone: this.formatarTelefoneString(parceiro.telefone),
            email: parceiro.email,
            tipoCadastro: parceiro.gplTipoCadastro || 'AVISTA',
            etapaCadastro: parceiro.gplEtapa || 'COMPLETO',
            ativo: parceiro.ativo !== 'N',
            isCliente: parceiro.cliente === 'S',
            isFornecedor: parceiro.fornecedor === 'S',
            isVendedor: parceiro.vendedor === 'S',
            isUsuario: parceiro.usuario === 'S',
            isTransportadora: parceiro.transportadora === 'S',
            isAgencia: parceiro.agencia === 'S',
            isMotorista: parceiro.motorista === 'S',
            rg: parceiro.rg,
            orgaoExpedidor: parceiro.orgaoExpedidor,
            dataEmissaoRg: parceiro.dataEmissaoRg ? new Date(parceiro.dataEmissaoRg).toISOString().split('T')[0] : '',
            cnh: parceiro.cnh,
            dataVencimentoCnh: parceiro.dataVencimentoCnh ? new Date(parceiro.dataVencimentoCnh).toISOString().split('T')[0] : '',
            nomeMae: parceiro.nomeMae,
            nomePai: parceiro.nomePai,
            sexo: parceiro.sexo || 'M',
            naturalidade: parceiro.naturalidade,
            dataNascimento: parceiro.dataNascimento ? new Date(parceiro.dataNascimento).toISOString().split('T')[0] : '',
            dataAbertura: parceiro.dataAbertura ? new Date(parceiro.dataAbertura).toISOString().split('T')[0] : '',
            com: parceiro.com,
            limiteCredito: this.formatarLimiteCredito(parceiro.limiteCredito),
            bloquearVendaPrazo: parceiro.bloquearVendaPrazo,
            vendedorResponsavel: parceiro.vendedorResponsavel,
            observacao: parceiro.observacao,
            gplConceito: parceiro.gplConceito || '',
            gplPendencia: parceiro.gplPendencia || 'OK',
            ipiEntrada: parceiro.ipiEntrada || '-1',
            ipiSaida: parceiro.ipiSaida || '-1',
            classificIcms: parceiro.classificIcms || 'C',
            consumidorFinal: (parceiro.classificIcms === 'C' || parceiro.classificIcms === 'X') ? 'S' : 'N',
            ipiIncideIcms: parceiro.ipiIncideIcms === 'S',
            temIpi: parceiro.temIpi === 'S',
            optanteSimples: parceiro.simples === 'S' || parceiro.simples === 'S',
            regimeTributario: parceiro.gplRegimeTributario || ''
        }, { emitEvent: false });

        // Atualiza o display visual do vendedor, caso exista
        if (parceiro.vendedorResponsavel && parceiro.vendedorResponsavel !== 0 && parceiro.vendedorResponsavel !== "0") {
            //@ts-ignore
            const vendedor = this.vendedores().find(v => String(v.codVend) === String(parceiro.vendedorResponsavel));
            if (vendedor) {
                this.inputVendedorDisplay.set(`${vendedor.codVend} - ${vendedor.apelido}`);
            }
        }

        // 2. Limpar os FormArrays antes de preenchê-los
        while (this.enderecosFormArray.length) this.enderecosFormArray.removeAt(0);
        while (this.contatosFormArray.length) this.contatosFormArray.removeAt(0);
        while (this.aeronavesFormArray.length) this.aeronavesFormArray.removeAt(0);
        while (this.compradoresFormArray.length) this.compradoresFormArray.removeAt(0);

        // 3. Preencher Endereços
        if (parceiro.listaEndereco && parceiro.listaEndereco.length > 0) {
            parceiro.listaEndereco.forEach((end: any) => {
                const enderecoGroup = this.criarEndereco();
                enderecoGroup.patchValue({
                    codparc: end.codparc || null,
                    tipoEndereco: end.gplTipoEndereco || '',
                    codCid: end.CODCID || '',
                    codEnd: end.CODEND || '',
                    codBai: end.CODBAI || '',
                    cep: this.formatarCepString(end.CEP),
                    complemento: end.COMPLEMENTO || '',
                    numeroEndereco: end.NUMEND || '',
                    inscricaoEstadual: end.inscEstadual || ''
                });
                this.enderecosFormArray.push(enderecoGroup);
            });
        } else {
            // Se não vier nenhum endereço, mantém pelo menos uma linha em branco para o usuário digitar
            this.adicionarEndereco();
        }

        // 4. Preencher Contatos
        if (parceiro.listaContato && parceiro.listaContato.length > 0) {
            parceiro.listaContato.forEach((contato: any) => {
                const contatoGroup = this.criarContato();
                contatoGroup.patchValue({
                    codContato: contato.codContato || contato.CODCONTATO || null,
                    tipoTelefone: contato.tipoFone || 'Comercial',
                    nome: contato.nomeContato || '',
                    telefone: this.formatarTelefoneString(contato.telefone),
                    celular: this.formatarTelefoneString(contato.celular),
                    email: (contato.email || '').toLowerCase()
                });
                this.contatosFormArray.push(contatoGroup);
            });
        }

        // 5. Preencher Aeronaves
        if (parceiro.listaAeronave && parceiro.listaAeronave.length > 0) {
            parceiro.listaAeronave.forEach((aero: any) => {
                const aeronaveGroup = this.criarAeronave();
                aeronaveGroup.patchValue({
                    codAero: aero.codaero || '',
                    tipoVinculo: aero.tipoVinculo || aero.TIPO_VINCULO || ''
                });
                this.aeronavesFormArray.push(aeronaveGroup);
            });
        }

        // 6. Preencher Compradores Autorizados (mesmo que a lista venha vazia, previne erros)
        if (parceiro.listaCompradoresAutorizados && parceiro.listaCompradoresAutorizados.length > 0) {
            parceiro.listaCompradoresAutorizados.forEach((comprador: any) => {
                const compradorGroup = this.criarComprador();
                compradorGroup.patchValue({
                    nome: comprador.nome || '',
                    cpf: this.formatarCPF(comprador.cpf) || ''
                });
                this.compradoresFormArray.push(compradorGroup);
            });
        }

        // 6.1 Referências bancárias
        while (this.refsBancariasFormArray.length) this.refsBancariasFormArray.removeAt(0);
        (parceiro.listaRefBancarias || []).forEach((r: any) => {
            const g = this.criarRefBancaria(r.ativa !== 'N');
            g.patchValue({
                codBanco: r.codBanco || '',
                tipoConta: r.tipoConta || 'Corrente',
                agencia: r.agencia || '',
                digAgencia: r.digAgencia || '',
                conta: r.conta || '',
                digConta: r.digConta || '',
                contaPgto: r.contaPgto === 'S',
                tipoChavePix: r.tipoChavePix || '',
                chavePix: r.chavePix || '',
                descricao: r.descricao || ''
            }, { emitEvent: false });
            this.refsBancariasFormArray.push(g);
        });
        this.refsBancariasQtdOriginal = this.refsBancariasFormArray.length;

        // 7. Preencher Fiadores e Alimentar Cache Visual
        if (parceiro.listaFiadores && parceiro.listaFiadores.length > 0) {
            parceiro.listaFiadores.forEach((fiador: any) => {
                const fiadorGroup = this.criarFiador();
                fiadorGroup.patchValue({
                    codParcFiador: fiador.codParcFiador || '',
                    funcao: fiador.funcao || '',
                });
                this.fiadoresFormArray.push(fiadorGroup);

                if (fiador.codParcFiador) {
                    const listaAtual = this.parceirosSankhya();
                    if (!listaAtual.some(p => String(p.CODPARC) === String(fiador.codParcFiador))) {
                        this.parceirosSankhya.set([
                            ...listaAtual,
                            {
                                CODPARC: fiador.codParcFiador,
                                NOMEPARC: fiador.nomeFiador || fiador.nome || 'Fiador Vinculado'
                            }
                        ]);
                    }
                }
            });
        }
    }

    // ==========================================
    // INTEGRAÇÃO SANKHYA
    // ==========================================
    carregarListasIniciais(): void {
        this.executarConsultaSankhya('', 'CIDADE');
        this.executarConsultaSankhya('', 'BAIRRO');
        this.executarConsultaSankhya('', 'LOGRADOURO');
        this.executarConsultaSankhya('', 'AERONAVE');
        this.carregarUfs();
    }

    async carregarUfs() {
        try {
            // Chame seu gateway que faz a query na tabela de UFs (ex: TGFUFS)
            const res: any = await firstValueFrom(this.sankhyaGateway.buscarUfs());
            
            // Ajuste o parse dependendo de como sua API retorna
            const listaUfs = res?.responseBody?.result || [];

            const ufsFormatadas = listaUfs.map((row: any[]) => ({
                CODUF: row[0], // Pega a posição 0 (Ex: '1')
                UF: row[1],    // Pega a posição 1 (Ex: 'SP')
                NOME: row[2]   // Pega a posição 2 (Ex: 'São Paulo')
            }));

            this.ufs.set(ufsFormatadas);
        } catch (e) {
            console.error('Erro ao carregar UFs do Sankhya:', e);
        }
    }

    async executarConsultaSankhya(termo: string, tipo: 'CIDADE' | 'BAIRRO' | 'LOGRADOURO' | 'AERONAVE') {
        try {
            let res: any;
            if (tipo === 'CIDADE') {
                res = await firstValueFrom(this.sankhyaGateway.buscarCidades(termo));
                let novas = this.formatarRetornoDataset(res, ["CODCID", "NOMECID", "UF"]);

                if (novas.length === 0 && termo) {
                    const termoSemAcento = termo.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
                    if (termo !== termoSemAcento) {
                        res = await firstValueFrom(this.sankhyaGateway.buscarCidades(termoSemAcento));
                        novas = this.formatarRetornoDataset(res, ["CODCID", "NOMECID", "UF"]);
                    }
                }
                this.cidades.update((curr: any[]) => this.mesclarListas(curr, novas, 'CODCID'));
            }
            else if (tipo === 'BAIRRO') {
                res = await firstValueFrom(this.sankhyaGateway.buscarBairros(termo));
                const novas = this.formatarRetornoDataset(res, ["CODBAI", "NOMEBAI"]);
                this.bairros.update((curr: any[]) => this.mesclarListas(curr, novas, 'CODBAI'));
            }
            else if (tipo === 'LOGRADOURO') {
                res = await firstValueFrom(this.sankhyaGateway.buscarLogradouros(termo));
                const novas = this.formatarRetornoDataset(res, ["CODEND", "NOMEEND"]);
                this.logradouros.update((curr: any[]) => this.mesclarListas(curr, novas, 'CODEND'));
            } 
            else if (tipo === 'AERONAVE') {
                res = await firstValueFrom(this.sankhyaGateway.buscarAeronaves(termo));
                const novas = this.formatarRetornoDataset(res, ["CODAERO", "PREFIXO"]);
                this.aeronaves.update((curr: any[]) => this.mesclarListas(curr, novas, 'CODAERO'));
            }
        } catch (e) {
            console.error(`Erro ao buscar ${tipo}:`, e);
        }
    }

    onFiltroBuscaChange(termo: string, tipo: 'CIDADE' | 'BAIRRO' | 'LOGRADOURO' | 'AERONAVE'): void {
        this.filtroBusca.set(termo);
        if (this.debounceConsulta) clearTimeout(this.debounceConsulta);
        this.debounceConsulta = setTimeout(() => {
            this.executarConsultaSankhya(termo, tipo as any);
        }, 400);
    }

    valorExibido(codigo: any, lista: any[], propCod: string, propDesc: string): string {
        const codStr = (codigo || '').toString().trim();
        if (!codStr) return '';
        const item = lista.find(x => x[propCod].toString() === codStr);
        return item ? `${codStr} - ${item[propDesc]}` : codStr;
    }

    valorExibidoCidade(codigo: any): string {
        const codStr = (codigo || '').toString().trim();
        if (!codStr) return '';

        //@ts-ignore
        const item = this.cidades().find(x => x.CODCID.toString() === codStr);
        
        if (item) {
            const siglaUf = this.obterSiglaUf(item.UF);
            return siglaUf ? `${codStr} - ${item.NOMECID} (${siglaUf})` : `${codStr} - ${item.NOMECID}`;
        }
        
        return codStr;
    }

    onInputCodigo(event: Event, controlName: string, index: number, formArray: FormArray): void {
        const input = event.target as HTMLInputElement;
        const valorDigitado = input.value;
        const cursorPos = input.selectionStart ?? valorDigitado.length;
        const idx = valorDigitado.indexOf(' - ');
        const novoCodigo = idx >= 0 ? valorDigitado.substring(0, idx) : valorDigitado;

        formArray.at(index).get(controlName)?.setValue(novoCodigo, { emitEvent: false });

        setTimeout(() => {
            const novaPos = Math.min(cursorPos, novoCodigo.length);
            input.setSelectionRange(novaPos, novaPos);
        });
    }

    limparCampoConsulta(controlName: string, index: number, formArray: FormArray): void {
        formArray.at(index).get(controlName)?.setValue('');
    }

    exibirToast(mensagem: string, tipo: 'success' | 'danger' | 'warning' | 'info' = 'success') {
        this.toast.set({ mensagem, tipo });
        setTimeout(() => this.toast.set(null), 4000);
    }

    // ==========================================
    // MODALS DE BUSCA
    // ==========================================

    // Cidades
    abrirBuscaCidade(index: number): void {
        this.indiceBuscaAtiva.set(index);
        this.filtroBusca.set('');
        this.ufSelecionada.set('');
        this.cidadeModalAberta.set(true);
    }
    cidadesFiltradas() {
        const termo = this.filtroBusca().trim().toLowerCase();
        const ufFiltro = this.ufSelecionada();
        // @ts-ignore
        return this.cidades().filter(c => {
            const passaTermo = termo ? c.NOMECID.toLowerCase().includes(termo) : true;
            const passaUf = ufFiltro ? (String(c.UF) === String(ufFiltro)) : true;

            return passaTermo && passaUf;
        });
    }
    selecionarCidade(item: any): void {
        this.enderecosFormArray.at(this.indiceBuscaAtiva()).get('codCid')?.setValue(item.CODCID);
        this.cidadeModalAberta.set(false);
    }

    // Logradouros
    abrirBuscaLogradouro(index: number): void {
        this.indiceBuscaAtiva.set(index);
        this.filtroBusca.set('');
        this.logradouroModalAberta.set(true);
    }
    logradourosFiltrados() {
        const termo = this.filtroBusca().trim().toLowerCase();
        // @ts-ignore
        return termo ? this.logradouros().filter(l => l.NOMEEND.toLowerCase().includes(termo)) : this.logradouros();
    }
    selecionarLogradouro(item: any): void {
        this.enderecosFormArray.at(this.indiceBuscaAtiva()).get('codEnd')?.setValue(item.CODEND);
        this.logradouroModalAberta.set(false);
    }

    // Bairros
    abrirBuscaBairro(index: number): void {
        this.indiceBuscaAtiva.set(index);
        this.filtroBusca.set('');
        this.bairroModalAberta.set(true);
    }
    bairrosFiltrados() {
        const termo = this.filtroBusca().trim().toLowerCase();
        // @ts-ignore
        return termo ? this.bairros().filter(b => b.NOMEBAI.toLowerCase().includes(termo)) : this.bairros();
    }
    selecionarBairro(item: any): void {
        this.enderecosFormArray.at(this.indiceBuscaAtiva()).get('codBai')?.setValue(item.CODBAI);
        this.bairroModalAberta.set(false);
    }

    // -- Aeronaves --

    abrirBuscaAeronave(index: number): void {
        this.indiceBuscaAtiva.set(index);
        this.filtroBusca.set('');
        this.aeronaveModalAberta.set(true);
    }

    aeronavesFiltradas() {
        const termo = this.filtroBusca().trim().toLowerCase();
        // @ts-ignore
        return termo ? this.aeronaves().filter(a => (a.PREFIXO || '').toLowerCase().includes(termo)) : this.aeronaves();
    }

    aeronavesFiltradasInline(index: number): any[] {
        const termo = (this.aeronavesFormArray.at(index).get('codAero')?.value || '').toString().toLowerCase();

        if (!termo) return this.aeronaves();

        // @ts-ignore
        return this.aeronaves().filter(a =>
            (a.PREFIXO || '').toLowerCase().includes(termo) ||
            a.CODAERO.toString().includes(termo)
        );
    }

    selecionarAeronave(item: any): void {
        this.aeronavesFormArray.at(this.indiceBuscaAtiva()).get('codAero')?.setValue(item.CODAERO);
        this.aeronaveModalAberta.set(false);
    }

    onInputAeronave(event: Event, index: number): void {
        const input = event.target as HTMLInputElement;
        const valorDigitado = input.value;

        // 1. Abre o dropdown se tiver algo digitado, fecha se estiver vazio
        if (valorDigitado.length > 0) {
            this.dropdownAeronaveAberto.set(index);
        } else {
            this.dropdownAeronaveAberto.set(-1);
        }

        // 2. Dispara a busca no Sankhya em tempo real (usa o seu debounce automático!)
        this.onFiltroBuscaChange(valorDigitado, 'AERONAVE');

        // 3. Mantém a sua lógica original de input para o formulário
        this.onInputCodigo(event, 'codAero', index, this.aeronavesFormArray);
    }

    selecionarAeronaveInline(item: any, index: number): void {
        this.aeronavesFormArray.at(index).get('codAero')?.setValue(item.CODAERO);
        this.dropdownAeronaveAberto.set(-1); // Fecha o dropdown
    }

    fecharDropdownAeronave(): void {
        // Usamos um pequeno timeout de segurança apenas para garantir que o clique
        // no item processe antes do blur fechar a caixa de opções.
        setTimeout(() => this.dropdownAeronaveAberto.set(-1), 150);
    }

    // -- Vendedores --

    vendedoresFiltrados(): any[] {
        const termo = this.filtroVendedor().trim();
        const lista = this.vendedores();
        
        if (!termo) {
            return lista;
        }
        
        // Filtra por código ou apelido, case-insensitive
        const resultado = lista.filter((v: any) => {
            const codigo = String(v.codVend || '').toLowerCase();
            const apelido = String(v.apelido || '').toLowerCase();
            const termoLower = termo.toLowerCase();
            
            return codigo.includes(termoLower) || apelido.includes(termoLower);
        });
        
        console.log('Filtro:', termo, 'Resultados:', resultado);
        return resultado;
    }

    onInputVendedor(event: Event): void {
        const input = event.target as HTMLInputElement;
        const valorDigitado = input.value;

        // Abre o dropdown se tiver algo digitado
        if (valorDigitado.length > 1) {
            this.dropdownVendedorAberto.set(true);

            // Armazena o que o usuário está digitando
            this.inputVendedorDisplay.set(valorDigitado);
            
            // Aplica o filtro (sem tentar extrair código, busca no termo todo)
            this.inputVendedorDisplay.set(valorDigitado);
            this.filtroVendedor.set(valorDigitado);
        } else {
            this.dropdownVendedorAberto.set(false);
        }
    }

    selecionarVendedor(item: any): void {
        this.parceiroForm.get('vendedorResponsavel')?.setValue(item.codVend);
        this.inputVendedorDisplay.set(`${item.codVend} - ${item.apelido}`);
        this.dropdownVendedorAberto.set(false);
        this.filtroVendedor.set('');
    }

    fecharDropdownVendedor(): void {
        setTimeout(() => {
            this.dropdownVendedorAberto.set(false);
            // Se não selecionou nada, limpa o display
            if (!this.parceiroForm.get('vendedorResponsavel')?.value) {
                this.inputVendedorDisplay.set('');
            }
        }, 150);
    }

    valorExibidoVendedor(codigo: any): string {
        // Se há display temporário (durante typing), retorna esse
        if (this.inputVendedorDisplay()) {
            return this.inputVendedorDisplay();
        }
        // Senão, busca e formata o vendedor selecionado
        const codStr = (codigo || '').toString().trim();
        if (!codStr) return '';
        const item = this.vendedores().find((v: any) => v.codVend.toString() === codStr);
        return item ? `${codStr} - ${item.apelido}` : codStr;
    }

    // ==========================================
    // LOGICA MODAL: BUSCA DE FIADOR
    // ==========================================

    fecharModalFiador(): void {
        this.modalFiadorAberta.set(false);
        this.indiceFiadorAtivo = -1;
    }

    // ==========================================
    // BUSCA GERAL DE PARCEIRO (INLINE)
    // ==========================================
    agendarBuscaParceiroGeral(): void {
        if (this.buscaParceiroGeralTimer) {
            clearTimeout(this.buscaParceiroGeralTimer);
        }

        if (this.filtroBuscaModalParceiroGeral.trim().length < 2) {
            this.listaParceirosGeralSugeridos.set([]);
            this.statusBuscaParceiroGeral.set('Digite ao menos 2 caracteres para pesquisar...');
            this.dropdownBuscaParceiroGeralAberto = false;
            return;
        }

        this.dropdownBuscaParceiroGeralAberto = true;

        this.buscaParceiroGeralTimer = setTimeout(() => {
            this.statusBuscaParceiroGeral.set('Buscando parceiros...');

            this.sankhyaGateway.buscarClientesNativo(this.filtroBuscaModalParceiroGeral.trim()).subscribe({
                next: (value: any) => {
                    if (value?.status && value.status !== '1') {
                        this.listaParceirosGeralSugeridos.set([]);
                        this.statusBuscaParceiroGeral.set(value.statusMessage || 'A pesquisa nativa não retornou sucesso.');
                        return;
                    }

                    const dadosNativos = this.extrairDadosPesquisaNativaCliente(value);

                    // O normalizarParceiros que você já tem pega certinho o CODPARC e CGC_CPF do objeto nativo
                    const lista = this.normalizarParceiros(dadosNativos);

                    this.listaParceirosGeralSugeridos.set(lista);
                    this.statusBuscaParceiroGeral.set(lista.length ? '' : 'Nenhum parceiro localizado.');
                },
                error: () => this.statusBuscaParceiroGeral.set('Erro na comunicação ao buscar parceiros no Sankhya.')
            });
        }, 300);
    }

    selecionarParceiroGeral(parceiro: any): void {
        this.dropdownBuscaParceiroGeralAberto = false;
        this.buscaColapsada = true;

        const docLimpo = String(parceiro.docparc || '').replace(/\D/g, '');

        if (docLimpo) {
            if (docLimpo.length > 11) {
                this.parceiroForm.get('tipoPessoa')?.setValue('J');
            } else {
                this.parceiroForm.get('tipoPessoa')?.setValue('F');
            }

            this.parceiroForm.get('cpfCnpj')?.setValue(docLimpo);
            this.aplicarMascaraCpfCnpj({ target: { value: docLimpo } });
            this.onCpfCnpjBlur();
        } else {
            this.exibirToast('O parceiro selecionado não possui CPF/CNPJ cadastrado para importar os dados.', 'warning');
        }
    }

    // ==========================================
    // LÓGICA MODAL: BUSCA DE FIADOR
    // ==========================================

    abrirModalFiador(index: number): void {
        this.indiceFiadorAtivo = index;
        this.filtroBuscaModalFiador = '';
        this.statusBuscaFiador.set('Digite ao menos 2 caracteres para pesquisar...');
        this.listaFiadoresSugeridos.set([]);
        this.modalFiadorAberta.set(true);
    }

    agendarBuscaFiadoresModal(): void {
        if (this.buscaFiadorTimer) {
            clearTimeout(this.buscaFiadorTimer);
        }

        if (this.filtroBuscaModalFiador.trim().length < 2) {
            this.listaFiadoresSugeridos.set([]);
            this.statusBuscaFiador.set('Digite ao menos 2 caracteres para pesquisar...');
            return;
        }

        this.buscaFiadorTimer = setTimeout(() => {
            this.statusBuscaFiador.set('Buscando parceiros...');

            this.sankhyaGateway.buscarClientesNativo(this.filtroBuscaModalFiador.trim()).subscribe({
                next: (value: any) => {
                    if (value?.status && value.status !== '1') {
                        this.listaFiadoresSugeridos.set([]);
                        this.statusBuscaFiador.set(value.statusMessage || 'A pesquisa nativa não retornou sucesso.');
                        return;
                    }

                    // Utiliza o extrator nativo criado no passo anterior
                    const dadosNativos = this.extrairDadosPesquisaNativaCliente(value);
                    const lista = this.normalizarParceiros(dadosNativos);

                    this.listaFiadoresSugeridos.set(lista);
                    this.statusBuscaFiador.set(lista.length ? '' : 'Nenhum parceiro localizado.');
                },
                error: () => this.statusBuscaFiador.set('Erro na comunicação ao buscar parceiros.')
            });
        }, 300);
    }

    selecionarFiadorModal(parceiro: any): void {
        if (this.indiceFiadorAtivo >= 0) {
            // Atribui o código no FormArray
            this.fiadoresFormArray.at(this.indiceFiadorAtivo).get('codParcFiador')?.setValue(parceiro.codparc);

            // Alimenta o cache local de parceirosSankhya (que a função valorExibidoFiador lê para mostrar o nome)
            const listaAtual = this.parceirosSankhya();
            if (!listaAtual.some(p => p.CODPARC == parceiro.codparc)) {
                this.parceirosSankhya.set([
                    ...listaAtual,
                    { CODPARC: parceiro.codparc, NOMEPARC: parceiro.nomeparc }
                ]);
            }
        }

        this.fecharModalFiador();
        this.exibirToast('Fiador selecionado com sucesso!', 'success');
    }

    private extrairDadosPesquisaNativaCliente(value: any): any[] {
        const body = value?.responseBody || value;
        const jsonBruto = body?.json?.['$'] ?? body?.json?.$ ?? body?.json ?? '';

        if (!jsonBruto) return [];

        try {
            const resultado = typeof jsonBruto === 'string' ? JSON.parse(jsonBruto) : jsonBruto;
            return Array.isArray(resultado?.data) ? resultado.data : [];
        } catch (error) {
            console.error('Erro ao interpretar retorno do PesquisaSP.getSuggestion:', error);
            return [];
        }
    }

    private normalizarParceiros(lista: any[]): any[] {
        if (!Array.isArray(lista)) return [];
        const vistos = new Set<string>();
        const resultado: any[] = [];

        for (const item of lista) {
            const codparc = item.codparc || item.CODPARC;
            const nomeparc = item.nomeparc || item.NOMEPARC || item.nomeParc;
            const docparc = item.docparc || item.DOCPARC || item.CNPJ || item.CGC_CPF || '';

            if (!codparc || !nomeparc) continue;
            const chave = docparc.replace(/\D/g, '') || `COD:${codparc}`;

            if (!vistos.has(chave)) {
                vistos.add(chave);
                resultado.push({ codparc, nomeparc, docparc });
            }
        }
        return resultado;
    }

    cidadesFiltradasNaturalidade(): any[] {
        const termo = this.filtroNaturalidade().trim().toUpperCase();
        if (!termo) return this.cidades();
        return this.cidades().filter((c: any) => 
            (c.NOMECID || '').toUpperCase().includes(termo) || 
            c.CODCID.toString().includes(termo)
        );
    }

    onInputNaturalidade(event: Event): void {
        const input = event.target as HTMLInputElement;
        const valorDigitado = input.value;

        // Abre o dropdown se tiver algo digitado
        if (valorDigitado.length > 1) {
            this.dropdownNaturalidadeAberto.set(true);
        } else {
            this.dropdownNaturalidadeAberto.set(false);
        }

        // Extrai apenas a cidade (sem o código)
        const idx = valorDigitado.indexOf(' - ');
        const novaValor = idx >= 0 ? valorDigitado.substring(0, idx) : valorDigitado;

        this.parceiroForm.get('naturalidade')?.setValue(novaValor, { emitEvent: false });
        this.filtroNaturalidade.set(novaValor);

        // Mantém cursor na posição
        const cursorPos = input.selectionStart ?? valorDigitado.length;
        setTimeout(() => {
            const novaPos = Math.min(cursorPos, novaValor.length);
            input.setSelectionRange(novaPos, novaPos);
        });
    }

    selecionarNaturalidade(item: any): void {
        this.parceiroForm.get('naturalidade')?.setValue(item.CODCID);
        this.dropdownNaturalidadeAberto.set(false);
        this.filtroNaturalidade.set('');
    }

    fecharDropdownNaturalidade(): void {
        setTimeout(() => this.dropdownNaturalidadeAberto.set(false), 150);
    }

    valorExibidoNaturalidade(valor: any): string {
        const valStr = (valor || '').toString().trim();
        if (!valStr) return '';
        const item = this.cidades().find((c: any) => c.CODCID.toString() === valStr);
        return item ? `${item.CODCID} - ${item.NOMECID}` : valStr;
    }

    // ==========================================
    // FORM ARRAYS CRIADORES
    // ==========================================
    criarEndereco(): FormGroup {
        return this.fb.group({
            codparc: [null],
            tipoEndereco: [''],
            codCid: ['', Validators.required],
            codEnd: [''],
            codBai: [''],
            cep: [''],
            numeroEndereco: [''],
            complemento: [''],
            inscricaoEstadual: [''] // IE por endereço
        });
    }
    adicionarEndereco(): void { this.enderecosFormArray.push(this.criarEndereco()); }

    removerEndereco(index: number): void { 
        if (this.enderecosFormArray.length > 1) {
            const codparc = this.enderecosFormArray.at(index).get('codparc')?.value;
            
            // Se tinha codparc, significa que já existe no Sankhya. Guardamos na lista de exclusão!
            if (codparc) {
                this.enderecosParaExcluir.push(codparc);
            }
            
            this.enderecosFormArray.removeAt(index); 
        } 
    }

    criarComprador(): FormGroup {
        return this.fb.group({ nome: ['', Validators.required], cpf: ['', [cpfCompradorValidator()]] });
    }
    emailMaiusculo(event: Event, index: number): void {
        const input = event.target as HTMLInputElement;
        const valor = (input.value || '').toLowerCase();
        if (input.value !== valor) {
            input.value = valor;
        }
        this.contatosFormArray.at(index).get('email')?.setValue(valor, { emitEvent: false });
    }

    adicionarComprador(): void { this.compradoresFormArray.push(this.criarComprador()); }
    removerComprador(index: number): void { 
        const nomeComprador = this.compradoresFormArray.at(index).get('nome')?.value;

        if (nomeComprador) {
            this.compradoresParaExcluir.push({ nome: nomeComprador });
        }

        this.compradoresFormArray.removeAt(index);
     }
    criarContato(): FormGroup {
        return this.fb.group({ codContato: [''], tipoTelefone: ['Comercial'], nome: ['', Validators.required], telefone: [''], celular: [''], email: ['', [Validators.email]] });
    }
    adicionarContato(): void { this.contatosFormArray.push(this.criarContato()); }
    removerContato(index: number): void {
        const codContato = this.contatosFormArray.at(index).get('codContato')?.value;
        const codParc = this.enderecosFormArray.at(0)?.get('codparc')?.value;

        // Se possui chave primária ou vínculo existente, guarda para deletar no Sankhya
        if (codContato) {
            this.contatosParaExcluir.push({ codContato, codParc });
        }

        this.contatosFormArray.removeAt(index);
    }

    criarAeronave(): FormGroup {
        return this.fb.group({
            codAero: ['', Validators.required],
            tipoVinculo: ['', Validators.required]
        });
    }
    adicionarAeronave(): void { this.aeronavesFormArray.push(this.criarAeronave()); }
    removerAeronave(index: number): void {
        const codAero = this.aeronavesFormArray.at(index).get('codAero')?.value;
        const codParc = this.enderecosFormArray.at(0)?.get('codparc')?.value;

        // Se já existia vínculo salvo no banco, guarda para remoção da tabela AD_AEROPAR
        if (codAero && codParc) {
            this.aeronavesParaExcluir.push({ codAero, codParc });
        }

        this.aeronavesFormArray.removeAt(index);
    }

    criarFiador(): FormGroup {
        return this.fb.group({
            codParcFiador: ['', Validators.required],
            funcao: ['']
        });
    }

    adicionarFiador(): void {
        this.fiadoresFormArray.push(this.criarFiador());
    }

    removerFiador(index: number): void {
        const codParcFiador = this.fiadoresFormArray.at(index).get('codParcFiador')?.value;
        const codParcPrincipal = this.enderecosFormArray.at(0)?.get('codparc')?.value;

        // Se já existia vínculo salvo no banco, guarda para remoção da tabela GPL_FIADOR_PARCEIRO
        if (codParcFiador && codParcPrincipal) {
            this.fiadoresParaExcluir.push({ codParcPrincipal, codParcFiador });
        }

        this.fiadoresFormArray.removeAt(index);
    }


    // ==========================================
    // AÇÕES DO FORMULÁRIO E EVENTOS
    // ==========================================
    onFileSelected(event: any): void {
        const files: FileList = event.target.files;
        const tamanhoMaximoMB = 5;
        const tamanhoMaximoBytes = tamanhoMaximoMB * 1024 * 1024;
        if (files) {
            for (let i = 0; i < files.length; i++) {
                const arquivo = files[i];

                // 1. Validação de Tamanho
                if (arquivo.size > tamanhoMaximoBytes) {
                    this.exibirToast(`O arquivo "${arquivo.name}" excedeu o limite de ${tamanhoMaximoMB}MB e não foi anexado.`, 'warning');
                    continue; // Pula este arquivo e não adiciona na lista
                }

                // Opcional: Evitar adicionar o mesmo arquivo duplicado
                // @ts-ignore
                const fileExists = this.arquivosPendentes.some(f => f.name === arquivo.name && f.size === arquivo.size);

                if (!fileExists) {
                    this.arquivosPendentes.push(arquivo);
                }
            }
            console.log(`${this.arquivosPendentes.length} arquivo(s) na fila de upload.`);
        }

        // IMPORTANTE: Limpa o campo nativo para permitir somar novos arquivos continuamente sem bugar o (change)
        if (this.fileInput && this.fileInput.nativeElement) {
            this.fileInput.nativeElement.value = '';
        }
    }

    onLimparFormularioClick(): void {
        this.modalConfirmarLimparAberto.set(true);
    }

    confirmarLimpeza(): void {
        this.modalConfirmarLimparAberto.set(false);
        this.limparFormulario();
    }

    cancelarLimpeza(): void {
        this.modalConfirmarLimparAberto.set(false);
    }

    onSalvarParceiroClick(event?: Event): void {
        if (event) event.preventDefault();

        // Valida antes de abrir a modal para não perguntar à toa
        if (this.parceiroForm.invalid) {
            this.parceiroForm.markAllAsTouched();
            this.exibirToast('Preencha os campos obrigatórios em vermelho antes de salvar.', 'warning');
            return;
        }

        this.modalConfirmarSalvarAberto.set(true);
    }

    async confirmarSalvamento(): Promise<void> {
        if (this.salvando()) return;

        // Hide the modal before starting the save process
        this.modalConfirmarSalvarAberto.set(false);

        // Set the saving state to true to trigger loaders and disable buttons
        this.salvando.set(true);

        try {
            await this.salvarParceiro(); // Call the actual save logic
        } finally {
            // Re-enable interactions after the process completes (success or failure)
            this.salvando.set(false);
        }
    }

    cancelarSalvamento(): void {
        this.modalConfirmarSalvarAberto.set(false);
    }

    valorExibidoFiador(codigo: any, index: number): string {
        const codStr = (codigo || '').toString().trim();
        if (!codStr) return '';

        const item = this.parceirosSankhya().find(p => p.CODPARC.toString() === codStr);
        return item ? `${item.CODPARC} - ${item.NOMEPARC}` : codStr;
    }

    // NOVO MÉTODO: Exclui o anexo caso o usuário tenha selecionado errado
    removerArquivo(index: number): void {
        this.arquivosPendentes.splice(index, 1);
    }

    /**
     * Monta o payload de sincronização com o Aerosys pra UM parceiro
     * (CODPARC) já gravado no Sankhya -- ver
     * sankhyaGateway.sincronizarParceiroAerosys()/ParceiroAerosysComponent
     * no backend. O backend resolve sozinho, via
     * ParceiroGlobalSP.doBuscarParceiroPorCpfCnpj, o endereço em texto
     * livre e os dados de PF (rg/sexo/dataNascimento -- TGFPAR.
     * IDENTINSCESTAD/SEXO/DTNASC), então aqui só manda os dados que só
     * existem no formulário (contatos, flags de tipo de pessoa, inscrição
     * estadual do endereço específico sendo processado, etc.).
     * <p>
     * isCliente/isFornecedor/isUsuario/isTransportadora/isMotorista
     * viram vínculos TPS_PES no Aerosys (catálogo TIPO_PESSOA, IDs
     * confirmados pelo usuário: 1/2/3/4/5) -- isVendedor/isAgencia NÃO
     * têm TPS_ID confirmado ainda, então não são enviados.
     * <p>
     * OBS: substituiu um método antigo (não utilizado) que montava um
     * payload no formato do importador legado (PES_NOME/PES_FONE/...) --
     * formato diferente do contrato real da API do Aerosys
     * (nome/tipo/listaFone/... -- ver Pessoa.java/PesFone.java no projeto
     * Aerosys).
     */
    private montarPayloadAerosys(formValue: any, endereco: any, codParc: string | number): any {
        return {
            codParc,
            tipoPessoa: formValue.tipoPessoa,
            nome: formValue.nome,
            // PES_ETAPA / PES_STATUS / END_TIPO / DPJ_DATAABERT no Aerosys
            etapa: formValue.etapaCadastro || 'COMPLETO',
            ativo: formValue.ativo !== false,
            tipoEndereco: endereco?.tipoEndereco || '',
            classificIcms: formValue.classificIcms || '',
            consumidorFinal: formValue.consumidorFinal || '',
            dataAbertura: formValue.dataAbertura || '',
            razaoSocial: formValue.razaoSocial || formValue.nome,
            cpfCnpj: formValue.cpfCnpj,
            email: formValue.email || '',
            telefone: formValue.telefone || '',
            inscricaoEstadual: endereco?.inscricaoEstadual || '',
            limiteCredito: this.parseLimiteCredito(formValue.limiteCredito),
            observacao: formValue.observacao || '',
            // 0 = sem conceito no Sankhya: na edição o Aerosys preserva o conceito atual; na criação usa o padrão (1)
            codConceito: formValue.gplConceito ? Number(String(formValue.gplConceito).replace(/\D/g, '')) || 0 : 0,
            isCliente: !!formValue.isCliente,
            isFornecedor: !!formValue.isFornecedor,
            isUsuario: !!formValue.isUsuario,
            // "Vendedor" no Sankhya = "Funcionário" no Aerosys.
            isVendedor: !!formValue.isVendedor,
            // "Agência" no Sankhya = "Banco" no Aerosys.
            isAgencia: !!formValue.isAgencia,
            isTransportadora: !!formValue.isTransportadora,
            isMotorista: !!formValue.isMotorista,
            nomeMae: formValue.nomeMae || '',
            nomePai: formValue.nomePai || '',
            naturalidade: formValue.naturalidade || '',
            rg: formValue.rg || '',
            // BUG: lia "rgOrgaoExpedidor", mas o FormControl real do campo
            // "Órg. Expedidor" se chama "orgaoExpedidor" (ver template) --
            // por isso DPF_RG_ORGAO nunca recebia valor, mesmo depois da
            // coluna ser habilitada no Aerosys (2026-10-02).
            rgOrgao: formValue.orgaoExpedidor || '',
            // Faltava mandar junto -- o campo "Emissão RG" existe no form
            // (dataEmissaoRg) e já ia pro Sankhya, mas nunca pro Aerosys.
            dataEmissaoRg: formValue.dataEmissaoRg || '',
            cnh: formValue.cnh || '',
            dataNascimento: formValue.dataNascimento || '',
            dataVencimentoCnh: formValue.dataVencimentoCnh || '',
            sexo: formValue.sexo || 'M',
            gplPendencia: formValue.gplPendencia || 'OK',
            vendedorResponsavel: formValue.vendedorResponsavel || '',
            // O Aerosys nao tem o codVend do Sankhya -- so da pra casar o
            // vendedor (PES_ID_VEND) por NOME, entao manda o apelido aqui
            // (mesmo texto exibido no combo "Vendedor Responsável").
            vendedorNome: this.vendedores().find(v => String(v.codVend) === String(formValue.vendedorResponsavel))?.apelido || '',
            com: formValue.com || '',
            contatos: (formValue.contatos || []).map((c: any) => ({
                tipoTelefone: c.tipoTelefone || 'Comercial',
                nome: c.nome || '',
                email: (c.email || '').toLowerCase(),
                telefone: c.telefone || '',
                celular: c.celular || ''
            })),
            compradores: (formValue.compradores || []).map((c: any) => ({
                nome: c.nome || '',
                cpf: this.extrairNumeros(c.cpf) || ''
            })),
            aeronaves: (formValue.aeronaves || []).map((a: any) => ({
                codAero: a.codAero || ''
            })),
            refsBancarias: this.refsBancariasValidas(formValue).map((r: any) => ({
                codBanco: r.codBanco,
                tipoConta: r.tipoConta || '',
                agencia: r.agencia || '',
                digAgencia: r.digAgencia || '',
                conta: r.conta || '',
                digConta: r.digConta || '',
                contaPgto: r.contaPgto ? 'S' : 'N',
                ativa: r.ativa ? 'S' : 'N',
                tipoChavePix: r.tipoChavePix || '',
                chavePix: r.chavePix || '',
                descricao: r.descricao || ''
            })),
            // removeu todas as referências que existiam: o Aerosys precisa limpar as dele também
            refsBancariasLimpar: this.refsBancariasValidas(formValue).length === 0 && this.refsBancariasQtdOriginal > 0,
            fiadores: (formValue.fiadores || []).map((f: any) => ({
                codParcFiador: f.codParcFiador || '',
                // Não ia junto antes -- o combo "Função" (Avalista/Fiador/
                // Sócio) ficava preenchido na tela mas nunca chegava no
                // Aerosys.
                funcao: f.funcao || ''
            }))
        };
    }

    /**
     * Sincroniza (best-effort, não bloqueia o cadastro) o parceiro recém-
     * criado com o Aerosys -- ver montarPayloadAerosys(). Qualquer falha
     * (Aerosys fora do ar, sem permissão, etc.) só fica registrada no
     * console; o parceiro já está salvo no Sankhya de qualquer forma.
     */
    private async sincronizarComAerosys(formValue: any, endereco: any, codParc: string | number): Promise<void> {
        try {
            const payload = this.montarPayloadAerosys(formValue, endereco, codParc);
            const resultado: any = await firstValueFrom(this.sankhyaGateway.sincronizarParceiroAerosys(payload));
            if (!resultado?.sucesso) {
                console.warn(`Parceiro ${codParc} salvo no Sankhya, mas a sincronização com o Aerosys falhou:`, resultado?.erro);
            }
        } catch (e) {
            console.warn(`Parceiro ${codParc} salvo no Sankhya, mas a sincronização com o Aerosys falhou:`, e);
        }
    }

    /** Aplica trim() em todo texto do objeto (recursivo); números, datas e booleanos ficam como estão. */
    private removerEspacosExtremos<T>(valor: T): T {
        if (typeof valor === 'string') return valor.trim() as unknown as T;
        if (Array.isArray(valor)) return valor.map(v => this.removerEspacosExtremos(v)) as unknown as T;
        if (valor && typeof valor === 'object' && !(valor instanceof Date)) {
            const saida: any = {};
            for (const [chave, v] of Object.entries(valor as any)) saida[chave] = this.removerEspacosExtremos(v);
            return saida;
        }
        return valor;
    }

    async salvarParceiro(): Promise<void> {
        if (this.parceiroForm.invalid) {
            this.parceiroForm.markAllAsTouched();
            return;
        }
        
        this.salvando.set(true);
        
        try {
            // Antes de ler o formulário: converte logradouro/bairro que vieram como TEXTO em código.
            for (let k = 0; k < this.enderecosFormArray.length; k++) {
                await this.garantirCodigosDoEndereco(k);
            }

            // Remove espaços no começo e no fim de todos os campos de texto (nome, IE, e-mail, endereço etc.).
            const formValue = this.removerEspacosExtremos(this.parceiroForm.getRawValue());
            this.parceiroForm.patchValue(formValue, { emitEvent: false });
            const enderecos = formValue.enderecos || [];
            const contatosSalvar = formValue.contatos || [];
            const aeronavesSalvar = formValue.aeronaves || [];
            const compradoresSalvar = formValue.compradores || [];
            const fiadoresSalvar = formValue.fiadores || [];
            
            // Lista para armazenar os códigos dos parceiros criados
            const codigosParceirosCriados: string[] = [];
            
            // Itera pelos endereços e cria um registro por endereço
            for (let i = 0; i < enderecos.length; i++) {
                const endereco = enderecos[i];

                const values: any = {
                    '1': formValue.tipoPessoa,
                    '2': this.extrairNumeros(formValue.cpfCnpj),
                    '3': formValue.nome,
                    '4': formValue.razaoSocial || formValue.nome || '',
                    '5': this.extrairNumeros(formValue.telefone) || '',
                    '6': formValue.email || '',
                    '7': ((formValue.tipoPessoa == 'F') ? formValue.rg : endereco.inscricaoEstadual) || '',
                    '8': formValue.orgaoExpedidor || '',
                    '9': (formValue.tipoPessoa == 'F') ? this.formatarData(formValue.dataEmissaoRg) : this.formatarData(formValue.dataAbertura),
                    '10': formValue.naturalidade || '',
                    '11': this.formatarData(formValue.dataNascimento),
                    '12': (formValue.tipoPessoa == 'F') ? formValue.sexo || 'M' : '',
                    '13': formValue.nomeMae || '',
                    '14': formValue.nomePai || '',
                    '15': formValue.cnh || '',
                    '16': this.formatarData(formValue.dataVencimentoCnh),
                    '17': formValue.categoriaCnh || '',
                    '18': formValue.com || '',
                    '19': this.parseLimiteCredito(formValue.limiteCredito),
                    '20': formValue.vendedorResponsavel || '',
                    '21': formValue.observacao || '',
                    '22': formValue.isCliente ? 'S' : 'N',
                    '23': formValue.isFornecedor ? 'S' : 'N',
                    '24': formValue.isVendedor ? 'S' : 'N',
                    '25': formValue.isUsuario ? 'S' : 'N',
                    '26': formValue.isTransportadora ? 'S' : 'N',
                    '27': formValue.isAgencia ? 'S' : 'N',
                    '28': formValue.isMotorista ? 'S' : 'N',
                    '29': endereco.codCid,
                    '30': endereco.codEnd,
                    '31': endereco.codBai,
                    '32': this.extrairNumeros(endereco.cep),
                    '33': endereco.complemento || '',
                    '34': endereco.numeroEndereco || '',
                    '35': endereco.inscricaoEstadual || '',
                    '36': formValue.classificIcms || 'N',
                    '37': formValue.bloquearVendaPrazo || 'N',
                    '38': formValue.ipiEntrada || '-1',
                    '39': formValue.ipiSaida || '-1',
                    '40': this.extrairNumeros(formValue.gplConceito) || '',
                    '41': formValue.gplPendencia || 'OK',
                    '42': formValue.ipiIncideIcms ? 'S' : 'N',
                    '43': formValue.temIpi ? 'S' : 'N',
                    '44': formValue.optanteSimples ? 'S' : 'N',
                    '45': formValue.regimeTributario || '',
                    '46': formValue.tipoCadastro || 'AVISTA',
                    '47': endereco.tipoEndereco || '',
                    '48': this.dataHoraAgora(),
                    '49': formValue.etapaCadastro || 'COMPLETO',
                    '50': formValue.ativo === false ? 'N' : 'S'
                };

                // 1. Monta o objeto base do registro que vai dentro de 'records'
                const recordItem: any = {
                    values: values
                };

                // 2. Se existir codparc, é uma ATUALIZAÇÃO. Removemos do 'values' (se estivesse lá) e criamos o objeto 'pk'
                if (endereco.codparc) {
                    recordItem.pk = {
                        CODPARC: endereco.codparc
                    };
                }
                
                // Cria o payload da pessoa com dados base + endereço específico
                const payloadParceiro = {
                    entityName: 'Parceiro', // Tabela TGFPAR
                    standAlone: false,
                    fields: [
                        'CODPARC',              // 0 - Código (auto-gerado)
                        'TIPPESSOA',            // 1
                        'CGC_CPF',              // 2
                        'NOMEPARC',             // 3
                        'RAZAOSOCIAL',          // 4
                        'TELEFONE',             // 5
                        'EMAIL',                // 6
                        'IDENTINSCESTAD',                   // 7
                        'GPL_ORGAOEXPEDITORRG',           // 8
                        'GPL_DTEMISSAORG',           // 9
                        'ComplementoParc.NATURALIDADE',       //----      // 10
                        'DTNASC',               // 11
                        'SEXO',                 // 12
                        'ComplementoParc.MAE',              // 13
                        'ComplementoParc.PAI',              // 14
                        'ComplementoParc.NROCNH',                  // 15
                        'ComplementoParc.VENCIMENTOCNH',            // 16
                        'ComplementoParc.CATEGORIACNH', //17
                        'AD_COM',                  // 18
                        'LIMCRED',              // 19
                        'CODVEND',     //------------ // 20
                        'OBSERVACOES',          // 21
                        'CLIENTE',            // 22
                        'FORNECEDOR',         // 23
                        'VENDEDOR',           // 24
                        'USUARIO',            // 25
                        'TRANSPORTADORA',     // 26
                        'AGENCIA',            // 27
                        'MOTORISTA',          // 28
                        'CODCID',               // 29
                        'CODEND',               // 30
                        'CODBAI',               // 31
                        'CEP',                  // 32
                        'COMPLEMENTO',          // 33
                        'NUMEND',          // 34
                        'INSCESTADNAUF',    // 35
                        'CLASSIFICMS',        // 36
                        'BLOQUEAR',           // 37
                        'CSTIPIENT',           // 38
                        'CSTIPISAI',          // 39
                        'GPL_CODCONCEITO',       // 40
                        'GPL_PENDENCIA',              // 41
                        'IPIINCICMS',              // 42
                        'TEMIPI',                     // 43
                        'SIMPLES',             // 44
                        'GPL_REGIMETRIBUTARIO',      // 45
                        'GPL_TIPOCADASTRO',           // 46
                        'GPL_TIPOENDERECO',          // 47
                        'GPL_DTALTERACAO',           // 48 - data/hora da última alteração
                        'GPL_ETAPA',                 // 49 - etapa do cadastro (COMPLETO/PARCIAL)
                        'ATIVO'                      // 50 - ativo (S) / inativo (N)
                    ],
                    records: [
                        recordItem
                    ],
                    "crudListener": "br.com.sankhya.modelcore.crudlisteners.ParceiroCrudListener",
                    "txProperties": {
                        "parceiro.isAutoNum": "true",
                        "isNumeracaoAutomatica": true
                    },
                    "clientEventList": {
                        "clientEvent": [
                        { "$": "br.com.sankhya.actionbutton.clientconfirm" }
                        ]
                    }
                };
                
                // Salva o parceiro no Sankhya
                const resSalvar: any = await firstValueFrom(this.sankhyaGateway.salvarSankhyaPorEntidade(payloadParceiro));
                console.log(resSalvar);
                let codParc = resSalvar?.responseBody?.result?.[0]?.[0] || resSalvar?.result?.[0]?.[0];
                if (!codParc) {
                    const entity = resSalvar?.responseBody?.entities?.entity || resSalvar?.entities?.entity;
                    if (Array.isArray(entity)) {
                        codParc = entity[0]?.CODPARC?.['$'] || entity[0]?.CODPARC;
                    } else if (entity) {
                        codParc = entity.CODPARC?.['$'] || entity.CODPARC;
                    }
                }
                if (!codParc) {
                    codParc = resSalvar?.responseBody?.pk?.CODPARC || resSalvar?.pk?.CODPARC;
                }
                
                if (codParc) {
                    codigosParceirosCriados.push(codParc);

                    // Sincroniza (best-effort) com o Aerosys -- cria a pessoa
                    // equivalente lá. Nunca bloqueia/desfaz o cadastro no
                    // Sankhya se falhar -- ver sincronizarComAerosys().
                    await this.sincronizarComAerosys(formValue, endereco, codParc);

                    // Salva contatos para este parceiro
                    if (contatosSalvar.length > 0) {
                        await this.salvarContatos(codParc, contatosSalvar);
                    }
                    
                    // Salva aeronaves para este parceiro
                    if (aeronavesSalvar.length > 0) {
                        await this.salvarAeronaves(codParc, aeronavesSalvar);
                    }

                    // Salva compradores autorizados para este parceiro
                    if (compradoresSalvar.length > 0) {
                        await this.salvarCompradores(codParc, compradoresSalvar);
                    }

                    await this.salvarRefsBancarias(codParc, formValue, !!endereco.codparc);

                    if (fiadoresSalvar.length > 0) {
                        const fiadoresSalvos = await this.salvarFiadores(codParc, fiadoresSalvar);
                        fiadoresSalvos;
                    }

                    if (this.contatosParaExcluir.length > 0) {
                        await this.excluirContatosRemovidosSankhya(codParc);
                    }

                    if (this.fiadoresParaExcluir.length > 0) {
                        await this.excluirFiadoresRemovidosSankhya(codParc);
                    }

                    if (this.compradoresParaExcluir.length > 0) {
                        await this.excluirCompradoresRemovidosSankhya(codParc);
                    }

                } else {
                    if (resSalvar?.statusMessage) {
                        throw new Error(`Erro ao salvar parceiro ${i + 1}: ${resSalvar.statusMessage}`);
                    }
                    throw new Error(`Erro ao salvar parceiro ${i + 1}: resposta inválida do servidor`);
                }
            }

            this.refsBancariasQtdOriginal = this.refsBancariasValidas(formValue).length;

            if (this.anexosParaExcluir.length > 0) {
                await this.excluirAnexosRemovidos();
            }

            if (this.arquivosPendentes.length > 0 || this.ordemAnexosAlterada) {
                // Fotografia da ordem (existentes + novos) antes de processarUploads limpar a fila.
                const ordemParaGravar = this.anexosOrdenados().map(a => a.key);
                // Pasta no Aerosys: Razão Social (PJ) ou Nome.
                const nomePastaAnexos = String(formValue.razaoSocial || formValue.nome || '');
                this.anexosAerosysEnviados = false;
                for (const codParc of codigosParceirosCriados) {
                    await this.processarUploads(codParc, ordemParaGravar, nomePastaAnexos);
                }
            }

            if (this.enderecosParaExcluir.length > 0) {
                await this.excluirEnderecosRemovidosSankhya();
            }

            if (this.aeronavesParaExcluir.length > 0) {
                await this.excluirAeronavesRemovidasSankhya();
            }

            this.exibirToast(`${codigosParceirosCriados.length} parceiro(s) cadastrado(s) com sucesso!`, 'success');
            this.limparFormulario();
            // Volta para a Lista de Parceiros (gateway troca a tela).
            // Pequeno atraso para o aviso de sucesso ser visto antes da troca.
            setTimeout(() => this.salvo.emit(), 1200);
            
        } catch (e) {
            console.error('Erro ao salvar parceiro:', e);
            this.exibirToast('Ocorreu um erro ao salvar o parceiro. Verifique o console para mais detalhes.', 'danger');
        } finally {
            this.salvando.set(false);
        }
    }
    
    private async salvarContatos(codParc: string | number, contatos: any[]): Promise<void> {
        for (const contato of contatos) {
            try {
                const values: any = {
                    '1': codParc,
                    '2': contato.nome || '',
                    '3': (contato.email || '').toLowerCase(),
                    '4': this.extrairNumeros(contato.telefone) || '',
                    '5': this.extrairNumeros(contato.celular) || '',
                    '6': contato.tipoTelefone || 'Comercial'
                }
                const recordItem: any = {
                    values: values
                };

                // 2. Se existir codparc, é uma ATUALIZAÇÃO. Removemos do 'values' (se estivesse lá) e criamos o objeto 'pk'
                if (contato.codcontato || contato.codContato) {
                    recordItem.pk = {
                        CODCONTATO: contato.codcontato || contato.codContato
                    };
                }

                const payloadContato = {
                    entityName: 'Contato', // Tabela geralmente TSICON ou similar
                    standAlone: false,
                    fields: ['CODCONTATO', 'CODPARC', 'NOMECONTATO', 'EMAIL', 'TELEFONE', 'CELULAR', 'GPL_TIPOFONE'],
                    records: [
                        recordItem
                    ]
                };
                
                await firstValueFrom(this.sankhyaGateway.salvarSankhyaPorEntidade(payloadContato));
            } catch (e) {
                console.error(`Erro ao salvar contato para parceiro ${codParc}:`, e);
            }
        }
    }
    
    private async salvarAeronaves(codParc: string | number, aeronaves: any[]): Promise<void> {
        for (const aero of aeronaves) {
            try {
                const values: any = {
                    '0': codParc,
                    '1': aero.codAero,
                    '2': aero.tipoVinculo
                }
                const recordItem: any = {
                    values: values
                };

                // 2. Se existir codparc, é uma ATUALIZAÇÃO. Removemos do 'values' (se estivesse lá) e criamos o objeto 'pk'
                if (aero.codparc || aero.codParc) {
                    recordItem.pk = {
                        CODPARC: aero.codparc || aero.codParc,
                        CODAERO: aero.codAero
                    };
                }

                // Vincula aeronave ao parceiro (tabela AD_AEROPAR)
                const payloadAero = {
                    entityName: 'AD_AEROPAR', // Tabela de relacionamento aeronave-parceiro
                    standAlone: false,
                    fields: ['CODPARC', 'CODAERO', 'TIPO_VINCULO'],
                    records: [
                        recordItem
                    ]
                };

                if (aero.codparc) {
                    payloadAero.records[0].pk = {
                        "CODPARC": codParc,
                        "CODAERO": aero.codAero
                    }
                }
                
                await firstValueFrom(this.sankhyaGateway.salvarSankhyaPorEntidade(payloadAero));
            } catch (e) {
                console.error(`Erro ao vincular aeronave para parceiro ${codParc}:`, e);
            }
        }
    }

    private async salvarCompradores(codParc: string | number, compradores: any[]): Promise<void> {
        for (const comp of compradores) {
            try {
                // Utilizando a extrairNumeros que já existe na sua classe para limpar o CPF
                const cpfLimpo = this.extrairNumeros(comp.cpf);

                const values: any = {
                    '0': codParc,
                    '1': comp.nome || '',
                    '2': cpfLimpo || ''
                }
                const recordItem: any = {
                    values: values
                };

                if (comp.codparc || comp.codParc) {
                    recordItem.pk = {
                        CODPARC: comp.codparc || comp.codParc,
                        CODAERO: comp.nome
                    };
                }

                const payloadComprador = {
                    entityName: 'GPL_CompradorAutorizado',
                    standAlone: false,
                    fields: ['CODPARC', 'NOME', 'CPF'],
                    records: [
                        recordItem
                    ]
                };
                
                await firstValueFrom(this.sankhyaGateway.salvarSankhyaPorEntidade(payloadComprador));
            } catch (e) {
                console.error(`Erro ao salvar comprador autorizado para parceiro ${codParc}:`, e);
            }
        }
    }

    /** Linhas com banco, agência ou conta preenchidos (as demais são descartadas). Banco é obrigatório p/ gravar. */
    private refsBancariasValidas(formValue: any): any[] {
        return (formValue?.refsBancarias || []).filter((r: any) => this.refBancariaPreenchida(r) && String(r.codBanco ?? '').trim());
    }

    /**
     * Grava as referências bancárias do CODPARC em GPL_REFBANC_PARCEIRO (sequência = posição na grade) e espelha a ATIVA
     * nos campos nativos da TGFPAR (CODAGE/CODCTABCO/CHAVEPIX) -- as inativas ficam só na tabela GPL (não aparecem na tela nativa).
     * Best-effort: falha aqui não desfaz o cadastro do parceiro.
     */
    private async salvarRefsBancarias(codParc: string | number, formValue: any, codParcJaExistia: boolean): Promise<void> {
        const refs = this.refsBancariasValidas(formValue);
        if (refs.length === 0 && this.refsBancariasQtdOriginal === 0) return;

        const campos = ['CODPARC', 'SEQUENCIA', 'CODBCO', 'TIPOCONTA', 'AGENCIA', 'DIGAGENCIA', 'CONTA', 'DIGCONTA',
            'CONTAPGTO', 'ATIVA', 'TIPOCHAVEPIX', 'CHAVEPIX', 'DESCRICAO', 'DHALTER'];

        for (let i = 0; i < refs.length; i++) {
            const r = refs[i];
            const seq = i + 1;
            const values: any = {
                '0': codParc, '1': seq, '2': r.codBanco, '3': r.tipoConta || '', '4': r.agencia || '', '5': r.digAgencia || '',
                '6': r.conta || '', '7': r.digConta || '', '8': r.contaPgto ? 'S' : 'N', '9': r.ativa ? 'S' : 'N',
                '10': r.tipoChavePix || '', '11': r.chavePix || '', '12': r.descricao || '', '13': this.dataHoraAgora()
            };
            const montar = (comPk: boolean) => ({
                entityName: 'GPL_RefBancariaParceiro',
                standAlone: false,
                fields: campos,
                records: [comPk ? { values, pk: { CODPARC: codParc, SEQUENCIA: seq } } : { values }]
            });
            try {
                const tentarAtualizar = codParcJaExistia && seq <= this.refsBancariasQtdOriginal;
                try {
                    await firstValueFrom(this.sankhyaGateway.salvarSankhyaPorEntidade(montar(tentarAtualizar)));
                } catch (e) {
                    if (!tentarAtualizar) throw e;
                    await firstValueFrom(this.sankhyaGateway.salvarSankhyaPorEntidade(montar(false)));
                }
            } catch (e) {
                console.error(`Erro ao salvar referência bancária ${seq} do parceiro ${codParc}:`, e);
                this.exibirToast('Não foi possível salvar uma das referências bancárias no Sankhya.', 'warning');
            }
        }

        // Sobraram sequências além das atuais (usuário removeu linhas): exclui.
        if (codParcJaExistia) {
            for (let seq = refs.length + 1; seq <= this.refsBancariasQtdOriginal; seq++) {
                try {
                    await firstValueFrom(this.sankhyaGateway.proxy('mge', 'DatasetSP.removeRecord', {
                        dataSetID: '00Z',
                        entityName: 'GPL_RefBancariaParceiro',
                        standAlone: false,
                        pks: [{ CODPARC: codParc, SEQUENCIA: seq }]
                    }));
                } catch (e) {
                    console.error(`Erro ao excluir referência bancária ${seq} do parceiro ${codParc}:`, e);
                }
            }
        }

        // Espelha a referência ATIVA (preferindo a de pagamento) nos campos nativos; sem ativa => limpa os nativos.
        const ativas = refs.filter((r: any) => r.ativa);
        const ativa = ativas.find((r: any) => r.contaPgto) || ativas[0];
        const conta = ativa ? `${ativa.conta || ''}${ativa.digConta ? '-' + ativa.digConta : ''}` : '';
        try {
            await firstValueFrom(this.sankhyaGateway.salvarSankhyaPorEntidade({
                entityName: 'Parceiro',
                standAlone: false,
                fields: ['CODPARC', 'CODAGE', 'CODCTABCO', 'CHAVEPIX', 'AD_TIPOCHAVEPIX'],
                records: [{
                    pk: { CODPARC: codParc },
                    values: { '0': codParc, '1': ativa ? (ativa.agencia || '') : '', '2': conta, '3': ativa ? (ativa.chavePix || '') : '',
                        '4': ativa ? (this.codigoTipoChavePixSankhya[ativa.tipoChavePix] || '') : '' }
                }]
            }));
        } catch (e) {
            console.warn(`Referência ativa não espelhada nos campos nativos do parceiro ${codParc}:`, e);
        }
    }

    private async salvarFiadores(codParcPrincipal: string | number, fiadores: any[]): Promise<void> {
        for (const fiador of fiadores) {
            // Ignora se o campo Parceiro Fiador estiver vazio
            if (!fiador.codParcFiador) continue;

            const values: any = {
                '0': codParcPrincipal,
                '1': fiador.codParcFiador,
                '2': fiador.funcao || ''
            }
            const recordItem: any = {
                values: values
            };

            if (fiador.codparc || fiador.codParc) {
                recordItem.pk = {
                    CODPARC: fiador.codparc || fiador.codParc,
                    CODPARCFIADOR: fiador.codParcFiador
                };
            }

            try {
                const payloadFiador = {
                    entityName: 'GPL_FiadorParceiro',
                    standAlone: false,
                    fields: ['CODPARC', 'CODPARCFIADOR', 'FUNCAO'],
                    records: [
                        recordItem
                    ]
                };

                await firstValueFrom(this.sankhyaGateway.salvarSankhyaPorEntidade(payloadFiador));
            } catch (e) {
                console.error(`Erro ao vincular fiador ${fiador.codParcFiador} para parceiro ${codParcPrincipal}:`, e);
            }
        }
    }

    // ==========================================
    // INTEGRAÇÃO VIACEP + SANKHYA
    // ==========================================
    async buscarCepNoSankhya(cep: string, index: number) {
        const enderecoGroup = this.enderecosFormArray.at(index);

        enderecoGroup.patchValue({ codCid: null, codBai: null, codEnd: null });

        try {
            const viaCepRes = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
            const dadosCep = await viaCepRes.json();

            if (dadosCep.erro) return;

            const nomeCidade = dadosCep.localidade;
            const nomeBairro = dadosCep.bairro;
            const nomeLogradouro = dadosCep.logradouro;

            // Busca Cidade
            if (nomeCidade) {
                let resCid = await firstValueFrom(this.sankhyaGateway.buscarCidades(nomeCidade));
                let listaCid = this.formatarRetornoDataset(resCid, ["CODCID", "NOMECID"]);

                if (listaCid.length === 0) {
                    const cidadeSemAcento = nomeCidade.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
                    if (nomeCidade !== cidadeSemAcento) {
                        resCid = await firstValueFrom(this.sankhyaGateway.buscarCidades(cidadeSemAcento));
                        listaCid = this.formatarRetornoDataset(resCid, ["CODCID", "NOMECID"]);
                    }
                }

                if (listaCid.length > 0) {
                    this.cidades.update((curr: any[]) => this.mesclarListas(curr, listaCid, 'CODCID'));
                    enderecoGroup.get('codCid')?.setValue(listaCid[0].CODCID);
                }
            }

            // Busca Bairro
            if (nomeBairro) {
                const resBai = await firstValueFrom(this.sankhyaGateway.buscarBairros(nomeBairro));
                const listaBai = this.formatarRetornoDataset(resBai, ["CODBAI", "NOMEBAI"]);
                if (listaBai.length > 0) {
                    this.bairros.update((curr: any[]) => this.mesclarListas(curr, listaBai, 'CODBAI'));
                    this.enderecosFormArray.at(index).get('codBai')?.setValue(listaBai[0].CODBAI);
                }
            }

            // Busca Logradouro
            if (nomeLogradouro) {
                const ruaCompleta = nomeLogradouro.trim();

                let resEnd = await firstValueFrom(this.sankhyaGateway.buscarLogradouros(ruaCompleta));
                let listaEnd = this.formatarRetornoDataset(resEnd, ["CODEND", "NOMEEND"]);

                if (listaEnd.length === 0) {
                    const primeiroEspaco = ruaCompleta.indexOf(' ');
                    if (primeiroEspaco !== -1) {
                        const nomeSemTipo = ruaCompleta.substring(primeiroEspaco + 1);
                        resEnd = await firstValueFrom(this.sankhyaGateway.buscarLogradouros(nomeSemTipo));
                        listaEnd = this.formatarRetornoDataset(resEnd, ["CODEND", "NOMEEND"]);
                    }
                }

                if (listaEnd.length > 0) {
                    this.logradouros.update((curr: any[]) => this.mesclarListas(curr, listaEnd, 'CODEND'));
                    this.enderecosFormArray.at(index).get('codEnd')?.setValue(listaEnd[0].CODEND);
                } else {
                    this.logradouroPendente.set({ nome: ruaCompleta, indexForm: index });
                    this.modalNovoLogradouroAberto.set(true);
                }
            }

        } catch (e) {
            console.error('Erro ao buscar o CEP:', e);
        }
    }

    async confirmarCadastroLogradouro() {
        this.salvando.set(true);
        const pendente = this.logradouroPendente();

        try {
            const ruaCompleta = pendente.nome.trim();
            const primeiroEspaco = ruaCompleta.indexOf(' ');

            let tipoRua = 'RUA';
            let nomeRua = ruaCompleta;

            if (primeiroEspaco !== -1) {
                tipoRua = ruaCompleta.substring(0, primeiroEspaco).toUpperCase();
                nomeRua = ruaCompleta.substring(primeiroEspaco + 1).toUpperCase();
            }

            const resSave: any = await firstValueFrom(
                this.sankhyaGateway.cadastrarLogradouro(tipoRua, nomeRua)
            );

            const novoCodEnd = resSave?.responseBody?.result?.[0]?.[0];

            if (novoCodEnd) {
                const novoItem = { CODEND: novoCodEnd, NOMEEND: ruaCompleta.toUpperCase() };
                this.logradouros.update((curr: any[]) => this.mesclarListas(curr, [novoItem], 'CODEND'));
                setTimeout(() => {
                    this.enderecosFormArray.at(pendente.indexForm).get('codEnd')?.setValue(novoCodEnd);
                }, 0);
            } else {
                const resBusca = await firstValueFrom(this.sankhyaGateway.buscarLogradouros(ruaCompleta));
                const listaEnd = this.formatarRetornoDataset(resBusca, ["CODEND", "NOMEEND"]);
                if (listaEnd.length > 0) {
                    this.logradouros.update((curr: any[]) => this.mesclarListas(curr, listaEnd, 'CODEND'));
                    setTimeout(() => {
                        this.enderecosFormArray.at(pendente.indexForm).get('codEnd')?.setValue(listaEnd[0].CODEND);
                    }, 0);
                }
            }

        } catch (e) {
            console.error('Erro ao cadastrar logradouro:', e);
            this.exibirToast('Ocorreu um erro ao tentar cadastrar o logradouro no Sankhya.', 'danger');
        } finally {
            this.salvando.set(false);
            this.modalNovoLogradouroAberto.set(false);
        }
    }

    async cadastrarNovaCidade() {
        const nomeCidade = this.filtroBusca().trim().toUpperCase();
        const ufId = this.ufSelecionada();
        const indexForm = this.indiceBuscaAtiva();

        if (!nomeCidade) return;

        this.salvando.set(true);
        try {
            const resSave: any = await firstValueFrom(this.sankhyaGateway.cadastrarCidade(nomeCidade, ufId));

            // Extrai o ID exatamente como fizemos no logradouro
            const novoCodCid = resSave?.responseBody?.result?.[0]?.[0];

            if (novoCodCid) {
                const novoItem = { CODCID: novoCodCid, NOMECID: nomeCidade };
                this.cidades.update((curr: any[]) => this.mesclarListas(curr, [novoItem], 'CODCID'));
                
                setTimeout(() => {
                    this.enderecosFormArray.at(indexForm).get('codCid')?.setValue(novoCodCid);
                }, 0);
                
                this.exibirToast('Cidade cadastrada e vinculada com sucesso!', 'success');
                this.cidadeModalAberta.set(false);
            } else {
                this.exibirToast('Cidade cadastrada, mas falha ao capturar o ID automaticamente.', 'warning');
            }
        } catch (e) {
            console.error('Erro ao cadastrar cidade:', e);
            this.exibirToast('Ocorreu um erro ao tentar cadastrar a cidade no Sankhya.', 'danger');
        } finally {
            this.salvando.set(false);
        }
    }

    async cadastrarNovoBairro() {
        const nomeBairro = this.filtroBusca().trim().toUpperCase();
        const indexForm = this.indiceBuscaAtiva();

        if (!nomeBairro) return;

        this.salvando.set(true);
        try {
            // OBS: Certifique-se de ter criado o método 'cadastrarBairro' no seu sankhyaGateway
            const resSave: any = await firstValueFrom(
                this.sankhyaGateway.cadastrarBairro(nomeBairro)
            );

            // Extrai o ID exatamente como fizemos no logradouro
            const novoCodBai = resSave?.responseBody?.result?.[0]?.[0];

            if (novoCodBai) {
                const novoItem = { CODBAI: novoCodBai, NOMEBAI: nomeBairro };
                this.bairros.update((curr: any[]) => this.mesclarListas(curr, [novoItem], 'CODBAI'));
                
                setTimeout(() => {
                    this.enderecosFormArray.at(indexForm).get('codBai')?.setValue(novoCodBai);
                }, 0);
                
                this.exibirToast('Bairro cadastrado e vinculado com sucesso!', 'success');
                this.bairroModalAberta.set(false);
            } else {
                this.exibirToast('Bairro cadastrado, mas falha ao capturar o ID automaticamente.', 'warning');
            }
        } catch (e) {
            console.error('Erro ao cadastrar bairro:', e);
            this.exibirToast('Ocorreu um erro ao tentar cadastrar o bairro no Sankhya.', 'danger');
        } finally {
            this.salvando.set(false);
        }
    }

    /**
     * Garante que logradouro/bairro do endereço estejam como CÓDIGO (CODEND/CODBAI)
     * antes de gravar no Sankhya. Quando o campo chega como TEXTO (ex.: endereço que já
     * existe no Aerosys e foi digitado/colado aqui), busca pelo nome no Sankhya e usa o
     * código; se não existir, cadastra e usa o código novo. Evita o erro
     * "Erro de conversão de valor para o campo 'CODEND'".
     */
    private async garantirCodigosDoEndereco(index: number): Promise<void> {
        const grupo = this.enderecosFormArray.at(index);
        const ehCodigo = (v: any) => /^\d+$/.test(String(v ?? '').trim());
        const norm = (s: string) => (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').trim().toUpperCase();

        // ── Logradouro ──
        const valEnd = grupo.get('codEnd')?.value;
        if (valEnd && !ehCodigo(valEnd)) {
            const nome = String(valEnd).replace(/^\d+\s*-\s*/, '').trim();
            const buscar = async () => this.formatarRetornoDataset(
                await firstValueFrom(this.sankhyaGateway.buscarLogradouros(nome)), ['CODEND', 'NOMEEND']);
            let lista = await buscar();
            if (lista.length === 0) {
                const sp = nome.indexOf(' ');
                const tipo = sp !== -1 ? nome.substring(0, sp) : 'RUA';
                const rua = sp !== -1 ? nome.substring(sp + 1) : nome;
                await firstValueFrom(this.sankhyaGateway.cadastrarLogradouro(tipo, rua));
                lista = await buscar();
            }
            const achado = lista.find((l: any) => norm(l.NOMEEND) === norm(nome)) || lista[0];
            if (!achado) throw new Error(`Logradouro "${nome}" não encontrado nem cadastrado no Sankhya.`);
            this.logradouros.update((curr: any[]) => this.mesclarListas(curr, lista, 'CODEND'));
            grupo.get('codEnd')?.setValue(achado.CODEND);
        }

        // ── Bairro ──
        const valBai = grupo.get('codBai')?.value;
        if (valBai && !ehCodigo(valBai)) {
            const nome = String(valBai).replace(/^\d+\s*-\s*/, '').trim();
            const buscar = async () => this.formatarRetornoDataset(
                await firstValueFrom(this.sankhyaGateway.buscarBairros(nome)), ['CODBAI', 'NOMEBAI']);
            let lista = await buscar();
            if (lista.length === 0) {
                await firstValueFrom(this.sankhyaGateway.cadastrarBairro(nome.toUpperCase()));
                lista = await buscar();
            }
            const achado = lista.find((b: any) => norm(b.NOMEBAI) === norm(nome)) || lista[0];
            if (!achado) throw new Error(`Bairro "${nome}" não encontrado nem cadastrado no Sankhya.`);
            this.bairros.update((curr: any[]) => this.mesclarListas(curr, lista, 'CODBAI'));
            grupo.get('codBai')?.setValue(achado.CODBAI);
        }
    }

    async cadastrarNovoLogradouro() {
        const nomeLogradouro = this.filtroBusca().trim();

        if (!nomeLogradouro) return;

        // 1. Alimenta o sinal que a função confirmarCadastroLogradouro() já utiliza
        this.logradouroPendente.set({
            nome: nomeLogradouro,
            indexForm: this.indiceBuscaAtiva()
        });

        // 2. Fecha a modal de busca atual
        this.logradouroModalAberta.set(false);

        // 3. Chama o método que já faz o split de RUA/AVENIDA e salva no Sankhya
        await this.confirmarCadastroLogradouro();
    }

    private anexosAerosysEnviados = false;

    async processarUploads(codParc: any, ordemParaGravar: string[] = [], nomePessoaAnexos = '') {
        // Envia os novos arquivos na ordem escolhida pelo usuario.
        const pos = (k: string) => { const i = ordemParaGravar.indexOf(k); return i < 0 ? Number.MAX_SAFE_INTEGER : i; };
        const pendentesOrdenados = [...this.arquivosPendentes].sort((a, b) => pos(a.name) - pos(b.name));
        for (const arquivo of pendentesOrdenados) {
            try {
                // Dispara o upload que já faz a vinculação automática
                const htmlResponse = await firstValueFrom(
                    this.sankhyaGateway.salvarAnexoParceiro(arquivo, arquivo.name, codParc)
                );
                
                console.log(`Upload concluído e vinculado com sucesso: ${codParc} ${arquivo.name}`);
                
            } catch (e) {
                console.error(`Erro no upload do arquivo ${arquivo.name}`, e);
            }
        }
        // Aerosys: manda os mesmos anexos novos (na ordem escolhida) para a pasta
        // cadastros/Pessoa/{Razão Social ou Nome}/ do servidor de documentos.
        // Só uma vez por salvamento (o mesmo conjunto vale para qualquer CODPARC).
        if (pendentesOrdenados.length > 0 && !this.anexosAerosysEnviados) {
            this.anexosAerosysEnviados = true;
            try {
                const nomePasta = (nomePessoaAnexos || '').trim();
                const r: any = await firstValueFrom(this.sankhyaGateway.enviarAnexosParceiroAerosys(nomePasta, pendentesOrdenados));
                if (!r?.sucesso) {
                    console.warn('Anexos do parceiro: envio ao Aerosys incompleto:', r);
                    this.exibirToast('Anexos salvos no Sankhya, mas houve falha ao enviar para o Aerosys.', 'warning');
                }
            } catch (e) {
                console.error('Erro ao enviar anexos do parceiro ao Aerosys:', e);
                this.exibirToast('Anexos salvos no Sankhya, mas houve falha ao enviar para o Aerosys.', 'warning');
            }
        }

        this.arquivosPendentes = [];

        // Grava a ordem final dos anexos deste parceiro (best-effort).
        if (ordemParaGravar.length > 0) {
            try {
                await firstValueFrom(this.sankhyaGateway.gravarOrdemAnexosParceiro(codParc, ordemParaGravar));
            } catch (e) {
                console.error(`Erro ao gravar a ordem dos anexos do parceiro ${codParc}`, e);
            }
        }
    }

    obterSiglaUf(codUf: any): string {
        if (!codUf) return '';
        //@ts-ignore
        const ufEncontrada = this.ufs().find(u => String(u.CODUF) === String(codUf));
        return ufEncontrada ? ufEncontrada.UF : codUf;
    }

    private formatarRetornoDataset(res: any, fields: string[]): any[] {
        const result = res?.responseBody?.result;
        if (!result || !Array.isArray(result)) return [];

        return result.map((row: any[]) => {
            const obj: any = {};
            fields.forEach((fieldName, index) => {
                obj[fieldName] = row[index] || '';
            });
            return obj;
        });
    }

    private mesclarListas(listaAtual: any[], novaLista: any[], idKey: string): any[] {
        const map = new Map();
        listaAtual.forEach(item => map.set(item[idKey], item));
        novaLista.forEach(item => map.set(item[idKey], item));
        return Array.from(map.values());
    }

    private extrairNumeros(valor: string): string {
        if (!valor) return '';
        return String(valor).replace(/\D/g, '');
    }

    private formatarData(data: string): string {
        if (!data) return '';
        // Converte de YYYY-MM-DD para DD/MM/YYYY
        const partes = data.split('-');
        if (partes.length === 3) {
            return `${partes[2]}/${partes[1]}/${partes[0]}`;
        }
        return data;
    }

    // ── Miniaturas dos anexos (imagem/PDF exibidos direto no card) ──
    private thumbs = new Map<string, { tipo: 'pdf' | 'img' | 'outro'; url: string; safe: SafeResourceUrl | null; carregando: boolean }>();

    thumbDe(it: { key: string; tipo: 'E' | 'P'; nome: string; ex?: any; file?: File }) {
        const id = it.tipo + ':' + it.key;
        let t = this.thumbs.get(id);
        if (t) return t;
        const info = this.tipoPorNome(it.tipo === 'E' ? (it.ex?.DESCRICAO || it.nome) : it.file!.name);
        t = { tipo: info.tipo, url: '', safe: null, carregando: it.tipo === 'E' && info.tipo !== 'outro' };
        this.thumbs.set(id, t);
        if (info.tipo === 'outro') return t;
        if (it.tipo === 'P') {
            this.definirThumb(t, it.file!, info);
        } else {
            void this.carregarThumbExistente(t, it.ex, info);
        }
        return t;
    }

    private definirThumb(t: { tipo: string; url: string; safe: SafeResourceUrl | null; carregando: boolean }, blob: Blob, info: { tipo: string; mime: string }) {
        t.url = URL.createObjectURL(new Blob([blob], { type: info.mime }));
        t.safe = info.tipo === 'pdf'
            ? this.sanitizer.bypassSecurityTrustResourceUrl(t.url + '#toolbar=0&navpanes=0&scrollbar=0&view=FitH')
            : null;
        t.carregando = false;
    }

    private async carregarThumbExistente(t: any, ex: any, info: { tipo: string; mime: string }) {
        try {
            const token: any = await firstValueFrom(this.sankhyaGateway.downloadAnexoParceiro(ex.CODATA, ex.DESCRICAO));
            const chave = token?.responseBody?.chaveAnexo?.idChaveAnexo;
            if (!chave) throw new Error('sem token');
            const resp: any = await firstValueFrom(this.sankhyaGateway.downloadAnexo(chave));
            this.definirThumb(t, resp.body, info);
        } catch (e) {
            t.tipo = 'outro';
            t.carregando = false;
        }
    }

    private limparThumbs(): void {
        this.thumbs.forEach(t => { if (t.url) URL.revokeObjectURL(t.url); });
        this.thumbs.clear();
    }

    // ── Preview de anexo (PDF ou imagem) ──
    private sanitizer = inject(DomSanitizer);
    previewAberto = signal(false);
    previewCarregando = signal(false);
    previewTipo: 'pdf' | 'img' | 'outro' = 'outro';
    previewNome = '';
    previewUrl: SafeResourceUrl | string = '';
    private previewObjUrl: string | null = null;
    private previewItem: { tipo: 'E' | 'P'; nome: string; ex?: any; file?: File } | null = null;

    /** Posição do anexo aberto no preview dentro da lista ordenada (-1 se não achar). */
    previewIndice(): number {
        const atual = this.previewItem;
        if (!atual) return -1;
        return this.anexosOrdenados().findIndex(a =>
            atual.tipo === 'E' ? a.ex === atual.ex : a.file === atual.file);
    }

    previewTotal(): number { return this.anexosOrdenados().length; }

    navegarPreview(delta: number): void {
        const lista = this.anexosOrdenados();
        const alvo = lista[this.previewIndice() + delta];
        if (alvo) void this.abrirPreviewAnexo(alvo);
    }

    @HostListener('document:keydown', ['$event'])
    onTeclaPreview(ev: KeyboardEvent): void {
        if (!this.previewAberto()) return;
        if (ev.key === 'ArrowRight') this.navegarPreview(1);
        else if (ev.key === 'ArrowLeft') this.navegarPreview(-1);
        else if (ev.key === 'Escape') this.fecharPreviewAnexo();
    }

    private tipoPorNome(nome: string): { tipo: 'pdf' | 'img' | 'outro'; mime: string } {
        const ext = (nome.split('.').pop() || '').toLowerCase();
        if (ext === 'pdf') return { tipo: 'pdf', mime: 'application/pdf' };
        const imgs: Record<string, string> = { jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', gif: 'image/gif', webp: 'image/webp', bmp: 'image/bmp' };
        if (imgs[ext]) return { tipo: 'img', mime: imgs[ext] };
        return { tipo: 'outro', mime: 'application/octet-stream' };
    }

    async abrirPreviewAnexo(it: { tipo: 'E' | 'P'; nome: string; ex?: any; file?: File }): Promise<void> {
        this.fecharPreviewAnexo();
        this.previewItem = it;
        const info = this.tipoPorNome(it.tipo === 'E' ? (it.ex?.DESCRICAO || it.nome) : it.file!.name);
        this.previewNome = it.tipo === 'E' ? (it.ex?.DESCRICAO || it.nome) : it.file!.name;
        this.previewTipo = info.tipo;
        this.previewAberto.set(true);
        if (info.tipo === 'outro') return;

        this.previewCarregando.set(true);
        try {
            let blob: Blob;
            if (it.tipo === 'P') {
                blob = it.file!;
            } else {
                const token: any = await firstValueFrom(this.sankhyaGateway.downloadAnexoParceiro(it.ex.CODATA, it.ex.DESCRICAO));
                const chave = token?.responseBody?.chaveAnexo?.idChaveAnexo;
                if (!chave) throw new Error('Token do arquivo não encontrado.');
                const resp: any = await firstValueFrom(this.sankhyaGateway.downloadAnexo(chave));
                blob = resp.body;
            }
            // Força o MIME correto (o servidor pode devolver octet-stream).
            const tipado = new Blob([blob], { type: info.mime });
            this.previewObjUrl = URL.createObjectURL(tipado);
            this.previewUrl = info.tipo === 'pdf'
                ? this.sanitizer.bypassSecurityTrustResourceUrl(this.previewObjUrl)
                : this.previewObjUrl;
        } catch (e) {
            console.error('Erro ao carregar preview do anexo:', e);
            this.previewTipo = 'outro';
        } finally {
            this.previewCarregando.set(false);
        }
    }

    fecharPreviewAnexo(): void {
        this.previewAberto.set(false);
        this.previewItem = null;
        if (this.previewObjUrl) {
            URL.revokeObjectURL(this.previewObjUrl);
            this.previewObjUrl = null;
        }
        this.previewUrl = '';
    }

    async fazerDownloadAnexo(anexo: any) {
        try {
            // 1. Gera o token usando o serviço Attach.view
            const responseToken: any = await firstValueFrom(
                this.sankhyaGateway.downloadAnexoParceiro(anexo.CODATA, anexo.DESCRICAO)
            );

            const idChaveAnexo = responseToken?.responseBody?.chaveAnexo?.idChaveAnexo;

            if (!idChaveAnexo) {
                console.error('Token do arquivo não encontrado na resposta do Sankhya.');
                return;
            }

            // 2. Chama o download, mas agora recebendo a resposta COMPLETA (headers + body)
            const responseDownload: any = await firstValueFrom(
                this.sankhyaGateway.downloadAnexo(idChaveAnexo)
            );

            // 3. Puxa o cabeçalho que expusemos no backend!
            const contentDisposition = responseDownload.headers.get('Content-Disposition');
            let nomeOriginal = anexo.DESCRICAO || 'documento'; // fallback de segurança

            // 4. Se o cabeçalho existir, extrai o filename original e a extensão
            if (contentDisposition) {
                const matches = /filename="?([^"]+)"?/.exec(contentDisposition);
                if (matches != null && matches[1]) {
                    nomeOriginal = matches[1];
                }
            }

            // 5. Força o download no navegador com o nome e extensão reais
            // Note que precisamos pegar o '.body' porque usamos observe: 'response'
            const blob = responseDownload.body;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = nomeOriginal; // AGORA SIM, O NOME VERDADEIRO!

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Erro ao baixar anexo:', error);
        }
    }

    // Função auxiliar para converter Base64 e disparar o download no navegador
    private baixarArquivoBase64(base64: string, nomeArquivo: string) {
        // Adiciona o prefixo caso o Sankhya não devolva (ajuste o mime-type se necessário)
        const base64Mime = base64.includes('data:') ? base64 : `data:application/octet-stream;base64,${base64}`;

        const link = document.createElement('a');
        link.href = base64Mime;
        link.download = nomeArquivo;

        // Anexa ao DOM, clica e remove (necessário para alguns navegadores)
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    async carregarAnexosDoParceiro(listaEndereco: any[]) {
        if (!listaEndereco || listaEndereco.length === 0) return;

        // 1. Extrai todos os codparcs válidos da lista de endereços
        const codigos = listaEndereco
            .map(end => parseInt(end.codparc, 10))
            .filter(cod => !isNaN(cod) && cod > 0);

        if (codigos.length === 0) return;

        // 2. Pega o menor codparc (Matriz / Cadastro Inicial)
        const menorCodParc = Math.min(...codigos);

        try {
            // 3. Chama o Gateway
            const res: any = await firstValueFrom(this.sankhyaGateway.buscarAnexosParceiro(menorCodParc));

            // O XML/JSON do Sankhya costuma retornar 'anexos.anexo'.
            // Se for um só, vem como objeto; se for mais de um, vem como array.
            let lista = res?.responseBody?.anexos?.anexo;

            if (!lista) {
                this.arquivosExistentes = [];
                return;
            }

            // Normaliza para array caso o Sankhya devolva um único objeto
            if (!Array.isArray(lista)) {
                lista = [lista];
            }

            // 4. Mapeia para o formato esperado pelo HTML e pela função de download
            this.arquivosExistentes = lista.map((anexo: any) => ({
                nomeArquivo: anexo.ARQUIVO,
                ARQUIVO: anexo.DESCRICAO, // Nome original do arquivo
                DESCRICAO: anexo.DESCRICAO,
                CODATA: anexo.CODATA, // O CODATA usado no anexo (ID do Parceiro)
            }));

            // 5. Aplica a ordem salva (GPL_PARCEIRO_ANEXO_ORDEM)
            try {
                const ro: any = await firstValueFrom(this.sankhyaGateway.buscarOrdemAnexosParceiro(menorCodParc));
                const ordem = (ro?.responseBody?.ordem ?? ro?.ordem ?? []) as { arquivo: string; ordem: number }[];
                this.ordemChavesAnexos = [...ordem].sort((a, b) => a.ordem - b.ordem).map(o => o.arquivo);
                this.ordemAnexosAlterada = false;
            } catch (e) {
                console.error('Erro ao buscar a ordem dos anexos:', e);
            }

        } catch (e) {
            console.error(`Erro ao buscar anexos para o codparc ${menorCodParc}:`, e);
        }
    }

    async preencherComReceitaWS(cnpj: string) {
        const cnpjLimpo = cnpj.replace(/\D/g, '');

        // Garante que é um CNPJ (14 dígitos)
        if (cnpjLimpo.length !== 14) return;

        this.exibirToast('Buscando dados na Receita Federal...', 'info');

        try {
            const dados: any = await firstValueFrom(this.sankhyaGateway.buscarDadosReceitaWS(cnpjLimpo));

            if (dados.status === 'ERROR') {
                this.exibirToast(`ReceitaWS: ${dados.message}`, 'warning');
                return;
            }

            // 1. Preenche os dados principais do Parceiro
            this.parceiroForm.patchValue({
                nome: dados.nome, // Razão Social
                razaoSocial: dados.fantasia || dados.nome, // Fantasia (fallback para Razão Social)
                email: dados.email || '',
                // A ReceitaWS pode retornar mais de um telefone separado por barra, pegamos o primeiro
                telefone: dados.telefone ? dados.telefone.split('/')[0].trim() : ''
            });

            // 2. Preenche os dados de Endereço (se houver a aba/form array de endereços)
            if (this.enderecosFormArray && this.enderecosFormArray.length > 0) {
                const primeiroEndereco = this.enderecosFormArray.at(0);
                const cepLimpo = dados.cep ? dados.cep.replace(/\D/g, '') : '';

                primeiroEndereco.patchValue({
                    cep: cepLimpo,
                    complemento: dados.complemento || '',
                });

                if (cepLimpo) {
                    this.onBlurCep({ target: { value: cepLimpo } }, 0);
                }
            }

            this.exibirToast('Dados da ReceitaWS carregados com sucesso!', 'success');

        } catch (e) {
            console.error('Erro ao consultar ReceitaWS:', e);
            this.exibirToast('Não foi possível buscar os dados na Receita Federal.', 'warning');
        }
    }

    private async excluirEnderecosRemovidosSankhya(): Promise<void> {
        for (const codparc of this.enderecosParaExcluir) {
            try {
                await firstValueFrom(this.sankhyaGateway.excluirParceiroSankhya(codparc));
                console.log(`Endereço/Parceiro filho (CODPARC: ${codparc}) excluído com sucesso do Sankhya.`);
            } catch (e) {
                console.error(`Erro ao tentar excluir o endereço CODPARC ${codparc} no Sankhya:`, e);
                this.exibirToast(`Não foi possível excluir um dos endereços removidos.`, 'warning');
            }
        }
    }

    private async excluirContatosRemovidosSankhya(codParc: string): Promise<void> {
        for (const item of this.contatosParaExcluir) {
            try {
                const payload = {
                    dataSetID: "02L",
                    entityName: "Contato", // Tabela TGFPCO / Contato
                    standAlone: false,
                    pks: [
                        {
                            CODCONTATO: item.codContato,
                            CODPARC: codParc
                        }
                    ]
                };

                await firstValueFrom(this.sankhyaGateway.proxy('mge', 'DatasetSP.removeRecord', payload));
                console.log(`Contato ${item.codContato} excluído do Sankhya com sucesso.`);
            } catch (e) {
                console.error(`Erro ao excluir contato ${item.codContato}:`, e);
                this.exibirToast(`Não foi possível excluir um dos contatos removidos.`, 'warning');
            }
        }
    }

    private async excluirAeronavesRemovidasSankhya(): Promise<void> {
        // Bug de build corrigido: chamava this.enderecosFormArray() (getter,
        // não função — TS6234 quebrava o build) num loop aninhado que nem
        // fazia sentido aqui — cada item de aeronavesParaExcluir já carrega
        // seu próprio codParc (ver linha ~1212, push({ codAero, codParc })),
        // igual ao padrão já usado por excluirFiadoresRemovidosSankhya logo
        // abaixo (item.codParcPrincipal / item.codParcFiador direto, sem
        // loop sobre enderecosFormArray).
        for (const item of this.aeronavesParaExcluir) {
            try {
                const payload = {
                    dataSetID: "00Z",
                    entityName: "AD_AEROPAR", // Tabela relacional
                    standAlone: false,
                    pks: [
                        { CODPARC: item.codParc, CODAERO: item.codAero }
                    ]
                };

                await firstValueFrom(this.sankhyaGateway.proxy('mge', 'DatasetSP.removeRecord', payload));
                console.log(`Vínculo de Aeronave ${item.codAero} com Parceiro ${item.codParc} excluído com sucesso.`);
            } catch (e) {
                console.error(`Erro ao excluir vínculo da aeronave ${item.codAero}:`, e);
                this.exibirToast(`Não foi possível remover o vínculo de uma das aeronaves.`, 'warning');
            }
        }
    }

    private async excluirFiadoresRemovidosSankhya(codParc: string): Promise<void> {
        for (const item of this.fiadoresParaExcluir) {
            try {
                const payload = {
                    dataSetID: "00Z",
                    entityName: "GPL_FiadorParceiro", // Tabela relacional
                    standAlone: false,
                    pks: [
                        { CODPARC: codParc, CODPARCFIADOR: item.codParcFiador }
                    ]
                };

                await firstValueFrom(this.sankhyaGateway.proxy('mge', 'DatasetSP.removeRecord', payload));
                console.log(`Vínculo de Fiador ${item.codParcFiador} com Parceiro ${item.codParcPrincipal} excluído com sucesso.`);
            } catch (e) {
                console.error(`Erro ao excluir vínculo do fiador ${item.codParcFiador}:`, e);
                this.exibirToast(`Não foi possível remover o vínculo de um dos fiadores.`, 'warning');
            }
        }
    }

    private async excluirCompradoresRemovidosSankhya(codParc: string): Promise<void> {
        for (const item of this.compradoresParaExcluir) {
            try {
                const payload = {
                    dataSetID: "00Z",
                    entityName: "GPL_CompradorAutorizado",
                    standAlone: false,
                    pks: [
                        { CODPARC: codParc, NOME: item.nome }
                    ]
                };

                await firstValueFrom(this.sankhyaGateway.proxy('mge', 'DatasetSP.removeRecord', payload));
                console.log(`Vínculo de Comprador ${item.codParcComprador} com Parceiro ${codParc} excluído com sucesso.`);
            } catch (e) {
                console.error(`Erro ao excluir vínculo do comprador ${codParc}:`, e);
                this.exibirToast(`Não foi possível remover o vínculo de um dos fiadores.`, 'warning');
            }
        }
    }

    // ==========================================
    // MÁSCARAS
    // ==========================================
    aplicarMascaraCpfCnpj(event: any): void {
        const tipoPessoa = this.parceiroForm.get('tipoPessoa')?.value;

        // Se for estrangeiro, ignora a formatação e aceita o que foi digitado
        if (tipoPessoa === 'E') {
            this.parceiroForm.get('cpfCnpj')?.setValue(event.target.value, {emitEvent: false});
            return;
        }

        let valor = event.target.value.replace(/\D/g, '');

        if (tipoPessoa === 'F') {
            if (valor.length > 11) valor = valor.substring(0, 11);
        } else {
            if (valor.length > 14) valor = valor.substring(0, 14);
        }

        if (tipoPessoa === 'F') {
            valor = valor.replace(/(\d{3})(\d)/, '$1.$2');
            valor = valor.replace(/(\d{3})(\d)/, '$1.$2');
            valor = valor.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
        } else {
            valor = valor.replace(/^(\d{2})(\d)/, '$1.$2');
            valor = valor.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
            valor = valor.replace(/\.(\d{3})(\d)/, '.$1/$2');
            valor = valor.replace(/(\d{4})(\d)/, '$1-$2');
        }

        this.parceiroForm.get('cpfCnpj')?.setValue(valor, {emitEvent: false});
    }


    aplicarMascaraSimplesCpf(event: any, index: number): void {
        let valor = event.target.value.replace(/\D/g, '');
        valor = valor.replace(/(\d{3})(\d)/, '$1.$2');
        valor = valor.replace(/(\d{3})(\d)/, '$1.$2');
        valor = valor.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
        if (valor.length > 14) valor = valor.substring(0, 14);
        this.compradoresFormArray.at(index).get('cpf')?.setValue(valor, { emitEvent: false });
    }

    aplicarMascaraCep(event: any, index: number): void {
        const valorFormatado = this.formatarCepString(event.target.value);
        this.enderecosFormArray.at(index).get('cep')?.setValue(valorFormatado, { emitEvent: false });
        event.target.value = valorFormatado;
    }

    formatarCepString(valor: any): string {
        if (!valor) return '';
        let valorPuro = String(valor).replace(/\D/g, '');
        let valorFormatado = valorPuro;

        if (valorPuro.length > 5) {
            valorFormatado = valorPuro.replace(/^(\d{5})(\d)/, '$1-$2');
        }

        if (valorFormatado.length > 9) {
            valorFormatado = valorFormatado.substring(0, 9);
        }

        return valorFormatado;
    }

    onBlurCep(event: any, index: number): void {
        let valorPuro = event.target.value.replace(/\D/g, '');
        if (valorPuro.length === 8) {
            this.buscarCepNoSankhya(valorPuro, index);
        }
    }

    aplicarMascaraTelefone(event: any): void {
        const valorFormatado = this.formatarTelefoneString(event.target.value);
        this.parceiroForm.get('telefone')?.setValue(valorFormatado, { emitEvent: false });
        event.target.value = valorFormatado;
    }

    aplicarMascaraTelefoneContato(event: any, index: number, campo: string): void {
        const valorFormatado = this.formatarTelefoneString(event.target.value);
        this.contatosFormArray.at(index).get(campo)?.setValue(valorFormatado, { emitEvent: false });
        event.target.value = valorFormatado;
    }

    formatarTelefoneString(valor: any): string {
        if (!valor) return '';
        const tipoPessoa = this.parceiroForm.get('tipoPessoa')?.value;
        let v = String(valor).replace(/\D/g, '');

        if (tipoPessoa === 'E') {
            return v.substring(0, 14);
        }

        if (v.length > 11) v = v.substring(0, 11);

        if (v.length > 2) {
            v = v.replace(/^(\d{2})(\d)/, '($1) $2');
        }
        if (v.length > 13) {
            v = v.replace(/(\d)(\d{4})$/, '$1-$2');
        } else if (v.length > 9) {
            v = v.replace(/(\d)(\d{4})$/, '$1-$2');
        }

        return v;
    }

    aplicarMascaraLimiteCredito(event: any): void {
        const input = event.target as HTMLInputElement;
        let valorDigitado = input.value.replace(/\D/g, ''); // Remove tudo que não é dígito

        // Converte para número e divide por 100 para obter o valor com 2 casas decimais
        const valorNumerico = valorDigitado ? parseInt(valorDigitado, 10) / 100 : 0;

        // Formata para exibição com R$ e 2 casas decimais
        const valorFormatado = `R$ ${valorNumerico.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

        // O controle guarda o texto formatado (o que aparece na tela); parseLimiteCredito converte ao salvar
        this.parceiroForm.get('limiteCredito')?.setValue(valorFormatado, { emitEvent: false });

        // Atualiza o input com o valor formatado
        input.value = valorFormatado;
    }

    /** Formata um valor numerico (ex.: 3800) como "R$ 3.800,00" para exibir no campo. */
    formatarLimiteCredito(valor: any): string {
        if (valor === null || valor === undefined || valor === '') {
            return '';
        }
        const n = typeof valor === 'number' ? valor : parseFloat(String(valor).replace(',', '.'));
        if (isNaN(n)) {
            return '';
        }
        return `R$ ${n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    }

    /** Converte o texto do campo ("R$ 3.800,00") para numero (3800). */
    parseLimiteCredito(texto: any): number {
        if (typeof texto === 'number') {
            return texto;
        }
        const digitos = String(texto ?? '').replace(/\D/g, '');
        return digitos ? parseInt(digitos, 10) / 100 : 0;
    }

    onKeyDownNavegacao(event: KeyboardEvent, contexto: 'NATURALIDADE' | 'VENDEDOR' | 'AERONAVE' | 'FIADOR', indexArray?: number): void {
        let lista: any[] = [];
        let estaAberto = false;

        // 1. Identifica qual lista usar baseado no contexto
        if (contexto === 'NATURALIDADE') {
            lista = this.cidadesFiltradasNaturalidade();
            estaAberto = this.dropdownNaturalidadeAberto();
        } else if (contexto === 'VENDEDOR') {
            lista = this.vendedoresFiltrados();
            estaAberto = this.dropdownVendedorAberto();
        } else if (contexto === 'AERONAVE') {
            lista = this.aeronavesFiltradasInline(indexArray!);
            estaAberto = this.dropdownAeronaveAberto() === indexArray;
        }

        // Se o dropdown não estiver aberto, deixa o teclado funcionar normalmente
        if (!estaAberto) return;

        const focoAtual = this.indiceFocoAtual();

        // 2. Aplica as regras de navegação
        if (event.key === 'ArrowDown') {
            event.preventDefault(); // Impede a tela de rolar
            this.indiceFocoAtual.update((i: any) => i < lista.length - 1 ? i + 1 : i);
        }
        else if (event.key === 'ArrowUp') {
            event.preventDefault();
            this.indiceFocoAtual.update((i: any) => i > 0 ? i - 1 : 0);
        }
        else if (event.key === 'Enter') {
            event.preventDefault(); // Evita salvar o formulário inteiro

            // Se tiver um item selecionado, executa a função correspondente
            if (focoAtual >= 0 && focoAtual < lista.length) {
                if (contexto === 'NATURALIDADE') this.selecionarNaturalidade(lista[focoAtual]);
                else if (contexto === 'VENDEDOR') this.selecionarVendedor(lista[focoAtual]);
                else if (contexto === 'AERONAVE') this.selecionarAeronaveInline(lista[focoAtual], indexArray!);
            }

            this.indiceFocoAtual.set(-1); // Reseta o índice de foco após a seleção
        }
        else if (event.key === 'Escape') {
            if (contexto === 'NATURALIDADE') this.fecharDropdownNaturalidade();
            else if (contexto === 'VENDEDOR') this.fecharDropdownVendedor();
            else if (contexto === 'AERONAVE') this.fecharDropdownAeronave();

            this.indiceFocoAtual.set(-1); // Reseta o índice de foco ao fechar o dropdown
        }
    }

    private formatarCPF(valor: any): string {
        if (!valor) return '';

        // Remove tudo o que não for dígito e garante que seja string
        let cpf = String(valor).replace(/\D/g, '');

        // Limita a 11 caracteres para evitar estouro de tamanho
        cpf = cpf.substring(0, 11);

        // Aplica a máscara progressivamente
        if (cpf.length <= 3) return cpf;
        if (cpf.length <= 6) return `${cpf.substring(0, 3)}.${cpf.substring(3)}`;
        if (cpf.length <= 9) return `${cpf.substring(0, 3)}.${cpf.substring(3, 6)}.${cpf.substring(6)}`;
        return `${cpf.substring(0, 3)}.${cpf.substring(3, 6)}.${cpf.substring(6, 9)}-${cpf.substring(9)}`;
    }

    formatarCpfCnpjExibicao(valor: any): string {
        if (!valor) return 'Não informado';

        let doc = String(valor).replace(/\D/g, '');

        if (doc.length <= 11) {
            // Garante os zeros à esquerda que o banco pode ter cortado
            doc = doc.padStart(11, '0');
            return doc.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
        } else {
            doc = doc.padStart(14, '0');
            return doc.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
        }
    }
}